import React, { useState, useEffect } from 'react';
import {
  Button,
  Stack,
  Container,
  Breadcrumb,
  Divider,
  Uploader,
  Table,
  Checkbox,
  Input,
  useToaster,
  Message,
  IconButton,
  Modal,
  FlexboxGrid,
  Col,
  SelectPicker,
  InputPicker,
  Loader,
  InputNumber,
  CheckPicker,
  Popover,
  Progress
} from 'rsuite';
import CameraRetroIcon from '@rsuite/icons/legacy/CameraRetro';
import TrashIcon from '@rsuite/icons/Trash';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import { Icon } from '@rsuite/icons';
import XLSX from 'xlsx';
import { ExcelRenderer } from 'react-excel-renderer';
import * as ExcelJS from 'exceljs';
import globalIP from '../../../GlobelIP';
import { Link } from 'react-router-dom';
import { values } from 'lodash';
import ugr from '@/UGRoute';
import img from './defImage/defaultimg.jpg';
import { Player } from '@lottiefiles/react-lottie-player';
import processdata from './animation/Animation - 1737444983597.json';
import addsubmit from './animation/Animation - 1737444747146.json';
import defaultImg from './defImage/defaultimg.jpg';

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const sizeUnit = [
  { label: 'CM', value: 'cm' },
  { label: 'Inch', value: 'inch' }
];
// const curnrecy = ['USD', 'INR', 'EURO', 'GBP'].map(item => ({ label: item, value: item }));
const curnrecy = [
  { label: 'USD', value: 'usd' },
  { label: 'INR', value: 'inr' },
  { label: 'EURO', value: 'euro' },
  { label: 'GBP', value: 'gbp' }
];
let categoryCodeCounter = 1;

const BulkProduct = () => {
  const ip = globalIP;
  const toaster = useToaster();
  const [category, setCategory] = useState(true);
  const [Productype, setProductype] = useState(true);
  const [image, setImage] = useState(true);
  const [image1, setImage1] = useState(false);
  const [sellingPrice, setSellingPrice] = useState(false);
  const [moq, setMoq] = useState(false);
  const [description, setDescription] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState(false);
  const [productCost, setProductCost] = useState(false);
  const [color, setColor] = useState(true);
  const [productID, setProductID] = useState(true);
  const [productname, setProductname] = useState(true);
  const [size, setSize] = useState(true);
  const [finish, setFinish] = useState(true);
  const [netWeight, setNetWeight] = useState(false);
  const [grossweight, setGrossweight] = useState(false);
  const [hsn, setHsn] = useState(true);
  const [sellingpriceU, setSellingpriceU] = useState(false);
  const [sellingpriceC, setSellingpriceC] = useState(false);
  const [productDesigner, setProductDesigner] = useState(false);
  const [madeby, setMadeby] = useState(false);
  const [buyername, setBuyername] = useState(false);
  const [buyersku, setBuyersku] = useState(false);
  const [length, setLength] = useState(true);
  const [width, setWidth] = useState(true);
  const [height, setHeight] = useState(true);
  const [cbm, setCbm] = useState(true);
  const [isLoading, setIsLoading] = useState(false); // Add the loading state
  const [isLoadsubmit, setIsLoadsubmit] = useState(false);
  const [datatotal, setDataTotal] = useState(0);
  const [data123, setData123] = useState([]);
  const [packagingBulkUpload, setPackagingBulkUpload] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [skippedRowsInfo, setSkippedRowsInfo] = useState([]);

  let generateNextCategoryCode = () => {
    let nextCode = datatotal;
    return nextCode;
  };

  useEffect(() => {
    if (!isLoading) {
      rows.forEach(row => {
        row.cbm = calculateCBM(row.SizeUnit, row.Length, row.Width, row.Height);
      });
    }
  }, [isLoading]);
  useEffect(() => {
    fetchData123();
  }, []);

  const fetchData123 = async () => {
    const response = await fetch(`${ip}/api/products?populate=*&pagination[page]=1`);
    const json = await response.json();
    const responsemeta = await fetch(`${ip}/api/products?populate=*&publicationState=preview`);
    const jsonmeta = await responsemeta.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(`${ip}/api/products?populate=*&pagination[page]=${page}`);
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setData123(allData);
    setDataTotal(jsonmeta.meta.pagination.total);
  };

  const [buyeerdata, setBuyeerdata] = useState([]);
  useEffect(() => {
    fetchDatab();
  }, []);
  const fetchDatab = async () => {
    try {
      const response = await fetch(`${ip}/api/buyer-details`);
      const json = await response.json();
      const processedData = json.data.map(item => ({
        label: item.attributes.buyernm,
        value: item.attributes.buyercode
      }));
      setBuyeerdata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [processedCount, setProcessedCount] = useState(0); // Track processed rows
  const [totalRows, setTotalRows] = useState(0); // Track total rows
  const [rows, setRows] = useState([
    {
      id: 1,
      CategoryCode: '',
      ProductTypeCode: '',
      ProductCode: '',
      ProductId: '',
      ProductName: '',
      Description: '',
      CartonType: 'master',
      PackagingSizeUnit: '',
      PackagingLength: 0,
      PackagingWidth: 0,
      PackagingHeight: 0,
      PackagingPCS: 0,
      PackagingCBM1: 0,
      PackagingNetWgt: 0,
      PackagingGrossWgt: 0,

      SizeUnit: '',
      Length: 0,
      Width: 0,
      Height: 0,
      FinishCode: '',
      ColorCode: '',
      NetWeight: 0,
      GrossWeight: 0,
      HSNCode: '',

      SellingPriceCurrency: '',
      SellingPriceUnit: '',
      SellingPrice: 0,
      ProductCost: 0,
      SearchKeyword: '',
      MOQ: 0,
      ProductDesigner: '',
      MadeBy: '',
      CategoryName: '',
      ProductTypeName: '',
      cbm: 0,
      FinishName: '',
      ColorName: '',
      BuyerName: '',
      BuyerSku: '',
      Product_Remark: '',
      Buyer_Remark: '',
      Shape: '',
      Season: '',
      P_Technique: '',
      SizeRange: '',
      Variant: false,
      SetStatus: 'Single',
      Part: 1,
      MaterialCollection: [
        {
          ProductCode: '',
          MatCollectionNm: '',
          MatCollectionCode: ''
        }
      ],
      ProductionDetail: [
        {
          ProductCode: '',
          MaterialNm: '',
          MaterialFinishNm: '',
          MatNetWeight: 0,
          MaterialCode: '',
          MaterialFinishCode: ''
        }
      ],
      CoverImage: null,
      MultipleImage: null,
      Total_CBM: 0,
      Total_CFT: 0,
      TwentyFT: '0',
      FortyFT: '0',
      FortyHQ: '0',
      Packaging: [
        {
          CartonType: '',
          ProductCode: '',
          Carton_Unit: '',
          Carton_Length: 0,
          Carton_Width: 0,
          Carton_Thick: 0,
          Carton_CBM: 0,
          Carton_PCS: 0,
          Carton_CBMperpc: 0,
          Carton_GrsWt: 0
        }
      ]
    }
  ]);
  // console.log('rows');
  // console.log(rows);

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        id: rows.length + 1,
        CategoryCode: '',
        ProductTypeCode: '',
        ProductCode: '',
        ProductId: '',
        ProductName: '',
        Description: '',
        SizeUnit: '',
        Length: 0,
        Width: 0,
        Height: 0,
        FinishCode: '',
        ColorCode: '',
        NetWeight: 0,
        GrossWeight: 0,
        HSNCode: '',
        SellingPriceCurrency: '',
        SellingPriceUnit: '',
        SellingPrice: 0,
        ProductCost: 0,
        SearchKeyword: '',
        MOQ: 0,
        ProductDesigner: '',
        MadeBy: '',
        CategoryName: '',
        ProductTypeName: '',
        cbm: 0,
        FinishName: '',
        ColorName: '',
        BuyerName: '',
        BuyerSku: '',
        Product_Remark: '',
        Buyer_Remark: '',
        Shape: '',
        Season: '',
        P_Technique: '',
        SizeRange: '',
        Variant: false,
        SetStatus: 'Single',
        Part: 1,
        MaterialCollection: [
          {
            ProductCode: '',
            MatCollectionNm: '',
            MatCollectionCode: ''
          }
        ],
        ProductionDetail: [
          {
            ProductCode: '',
            MaterialNm: '',
            MaterialFinishNm: '',
            MatNetWeight: 0,
            MaterialCode: '',
            MaterialFinishCode: ''
          }
        ],

        CoverImage: null,
        MultipleImage: null,
        Total_CBM: 0,
        Total_CFT: 0,
        TwentyFT: '0',
        FortyFT: '0',
        FortyHQ: '0',
        Packaging: [
          {
            CartonType: '',
            ProductCode: '',
            Carton_Unit: '',
            Carton_Length: 0,
            Carton_Width: 0,
            Carton_Thick: 0,
            Carton_CBM: 0,
            Carton_PCS: 0,
            Carton_CBMperpc: 0,
            Carton_GrsWt: 0
          }
        ]
      }
    ]);
    hide1();
  };
  const url4 = `${ip}/api/variant-products`;
  const hide = () => {
    let x = document.getElementById('add');
    x.style.display = 'none';
  };

  const hide1 = () => {
    let x = document.getElementById('add1');
    x.style.display = 'none';
  };

  // const uploadImage = (e) =>{
  //   hide1()
  // }

  // alert(rows.map((row) => row.ProductName))
  const handleRemoveRow = index => {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1);
    setRows(updatedRows);
  };
  const [selectedCategoryCode, setSelectedCategoryCode] = useState('');
  const [productTypeDataPerRow, setProductTypeDataPerRow] = useState({});
  const handleBlur = async (index, value) => {
    // Check if the entered ProductId already exists in other rows
    const duplicateRowIndex = rows.findIndex(
      (row, rowIndex) => rowIndex !== index && row.ProductId === value
    );

    if (duplicateRowIndex !== -1) {
      // Show an error message indicating the duplicate Alias Code and its line number
      console.log(`Line number ${duplicateRowIndex + 1} has the same Alias Code. Please change.`);
      // Or trigger any necessary action or display an error message here
    }
  };
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const generatecategorycode = startIndex => {
    return `CAT-${(startIndex + 1).toString().padStart(3, '0')}`;
  };
  const generateptypecode = startIndex => {
    return `PTY-${(startIndex + 1).toString().padStart(3, '0')}`;
  };
  const generatefinishcode = startIndex => {
    return `FIN-${(startIndex + 1).toString().padStart(3, '0')}`;
  };
  const generatecolorcode = startIndex => {
    return `CLR-${(startIndex + 1).toString().padStart(3, '0')}`;
  };
  const createEmptyRow = index => ({
    id: index, // or use a unique ID generator
    CategoryCode: '',
    ProductTypeCode: '',
    ProductCode: '',
    ProductId: '',
    ProductName: '',
    Description: '',
    SizeUnit: '',
    Length: 0,
    Width: 0,
    Height: 0,
    FinishCode: '',
    ColorCode: '',
    NetWeight: 0,
    GrossWeight: 0,
    HSNCode: '',
    SellingPriceCurrency: '',
    SellingPriceUnit: '',
    SellingPrice: 0,
    ProductCost: 0,
    SearchKeyword: '',
    MOQ: 0,
    ProductDesigner: '',
    MadeBy: '',
    CategoryName: '',
    ProductTypeName: '',
    cbm: 0,
    FinishName: '',
    ColorName: '',
    BuyerName: '',
    BuyerSku: '',
    Product_Remark: '',
    Buyer_Remark: '',
    Shape: '',
    Season: '',
    P_Technique: '',
    SizeRange: '',
    Variant: false,
    SetStatus: 'Single',
    Part: 1,
    MaterialCollection: [
      {
        ProductCode: '',
        MatCollectionNm: '',
        MatCollectionCode: ''
      }
    ],
    ProductionDetail: [
      {
        ProductCode: '',
        MaterialNm: '',
        MaterialFinishNm: '',
        MatNetWeight: 0,
        MaterialCode: '',
        MaterialFinishCode: ''
      }
    ],
    CoverImage: null,
    MultipleImage: null,
    Total_CBM: 0,
    Total_CFT: 0,
    TwentyFT: '0',
    FortyFT: '0',
    FortyHQ: '0',
    Packaging: [
      {
        CartonType: '',
        ProductCode: '',
        Carton_Unit: '',
        Carton_Length: 0,
        Carton_Width: 0,
        Carton_Thick: 0,
        Carton_CBM: 0,
        Carton_PCS: 0,
        Carton_CBMperpc: 0,
        Carton_GrsWt: 0
      }
    ]
  });
  // const handleChange2 = async (index, { CategoryName, CategoryCode, ProductTypeName }) => {
  //   setIsLoading(true);
  //   // Clone the current rows state to avoid mutating it directly
  //   const updatedRows = [...rows];

  //   // If the row at the given index does not exist, create an empty row and append it
  //   if (!updatedRows[index]) {
  //     updatedRows[index] = createEmptyRow(index);
  //   }

  //   // Handle CategoryName update
  //   if (CategoryName) {
  //     // console.log('Handling CategoryName');
  //     let selectedCategory = categorydata.find(
  //       item => item.label.toLowerCase() === CategoryName.toLowerCase()
  //     );

  //     const searchResponse = await fetch(`${ip}/api/mstcategories?fields[0]=CategoryName`);
  //     const searchData = await searchResponse.json();
  //     const nextCategoryCode = generatecategorycode(searchData.meta.pagination.total);

  //     if (!selectedCategory) {
  //       // console.log('entered not if catgory');

  //       await fetch(`${ip}/api/mstcategories?filters[CategoryName][$eq]=${CategoryName}`)
  //         .then(response => response.json())
  //         .then(searchData => {
  //           if (searchData.data.length === 0) {
  //             // If not found, make the POST request
  //             return fetch(`${ip}/api/mstcategories`, {
  //               method: 'POST',
  //               body: JSON.stringify({
  //                 data: {
  //                   CategoryName,
  //                   CategoryCode: nextCategoryCode,
  //                   dis: 'Continue'
  //                 }
  //               }),
  //               headers: { 'Content-Type': 'application/json' }
  //             })
  //               .then(response => response.json())
  //               .then(data => {
  //                 console.log(data);
  //                 fetchData(); // Fetch updated data
  //                 updatedRows[index].CategoryCode = nextCategoryCode;
  //               });
  //           } else {
  //             selectedCategory = true;
  //             // Category exists
  //             // console.log(`Category ${CategoryName} already exists.${searchData.data[0].attributes.CategoryCode}`);
  //             updatedRows[index].CategoryCode = searchData.data[0].attributes.CategoryCode;
  //           }
  //         })
  //         .catch(error => {
  //           console.error('Error:', error);
  //         });

  //       setSelectedCategoryCode(nextCategoryCode);
  //     } else {
  //       updatedRows[index].CategoryCode = selectedCategory.value;
  //     }
  //     // setCategorydata(prevData => [
  //     //   ...prevData,
  //     //   { label: updatedRows[index].CategoryName, value: updatedRows[index].CategoryCode }
  //     // ]);

  //     // setCategorydata(prevState => ({
  //     //   ...prevState,
  //     //   [ {label:updatedRows[index].CategoryName,value:updatedRows[index].CategoryCode}]
  //     // }));
  //     updatedRows[index].CategoryName = CategoryName;
  //     updatedRows[index].CategoryCode = nextCategoryCode;

  //     setSelectedCategoryCode(selectedCategory ? selectedCategory.value : '');

  //     if (selectedCategory) {
  //       try {
  //         const response = await fetch(
  //           `${ip}/api/mstproducttypes?populate=*&pagination[page]=1&filters[Categorycode][$eq]=${updatedRows[index].CategoryCode}`
  //         );
  //         const json = await response.json();
  //         const processedData = json.data.map(item => ({
  //           label: item.attributes.ProductTypeName,
  //           value: item.attributes.ProductTypeCode
  //         }));

  //         setProductTypeDataPerRow(prevState => ({
  //           ...prevState,
  //           Categorycode: nextCategoryCode,
  //           [index]: processedData
  //         }));
  //       } catch (error) {
  //         console.error('Error fetching product type data:', error);
  //       }
  //     } else {
  //       setProductTypeDataPerRow(prevState => ({
  //         ...prevState,
  //         [index]: []
  //       }));
  //     }
  //   }
  //   // fetchData()
  //   // Handle ProductTypeName update, only after CategoryName is processed
  //   if (ProductTypeName) {
  //     console.log('Handling ProductTypeName',CategoryName);

  //     const productTypeRequest = await fetch(
  //       `${ip}/api/mstproducttypes?populate=*&pagination[pageSize]=10000`
  //       );
  //     const ProductTypeResponse = await productTypeRequest.json();

  //     let selectedPtype = ProductTypeResponse.data.find(
  //       item => item.attributes.ProductTypeName.toLowerCase() === ProductTypeName.toLowerCase()
  //     );

  //     const searchResponse = await fetch(`${ip}/api/mstproducttypes?fields[0]=ProductTypeName`);
  //     const searchData = await searchResponse.json();
  //     const nextProductTypeCode = generateptypecode(searchData.meta.pagination.total);

  //     if (!selectedPtype) {
  //       // console.log('entered not if ptype');
  //       try {
  //         const formData = new FormData();
  //           formData.append(
  //             'data',
  //             JSON.stringify({
  //               ProductTypeName,
  //               ProductTypeCode: nextProductTypeCode,
  //               Categorycode: updatedRows[index].CategoryCode,
  //               dis: 'Continue'
  //             })
  //           );
  //           const response = await fetch(`${ip}/api/mstproducttypes`, {
  //             method: 'POST',
  //             body: formData
  //           });

  //           const data = await response.json();
  //           console.log(data);
  //           fetchData2();

  //       } catch (error) {
  //         console.error('Error checking and adding new product type:', error);
  //       }
  //     }
  //     else {
  //       console.log("Category Name :", CategoryName)
  //       console.log("CategoryCode :", CategoryCode)
  //       console.log("ProductTypeName :", ProductTypeName)
  //       try {

  //         const productTypeRequest = await fetch(
  //         `${ip}/api/mstproducttypes?populate=*&pagination[pageSize]=10000`
  //         );
  //         const ProductTypeResponse = await productTypeRequest.json();

  //         console.log("ProductTypeResponse Data :", ProductTypeResponse)

  //         // Find the category with the given Categorycode
  //         const foundProductType = ProductTypeResponse.data.filter(
  //           // (category) => category.attributes.Categorycode === Categorycode
  //           item => item.attributes.ProductTypeName.toLowerCase() === ProductTypeName.toLowerCase()

  //         );
  //         console.log("product type form database that have same pTypeName ", foundProductType)
  //         const categoryCodes = foundProductType.map(item => item.attributes.Categorycode);
  //         console.log("Category Code for matching pTypeName form category database : ",categoryCodes)

  //         // Construct the query string
  //         const queryString = categoryCodes
  //         .map(code => `filters[CategoryCode][$eq]=${code}`)
  //         .join('&');
  //         console.log("Final url : ",queryString)

  //         // console.log('Constructed Query String:', queryString);
  //         const finalUrl = `${ip}/api/mstcategories?populate=*&pagination[pageSize]=10000&${queryString}&populate=*`;

  //         // console.log('Final URL:', finalUrl);
  //         // console.log('hellloewe data mil faga :',foundProductType)
  //         const allCategoryReq = await fetch(finalUrl)
  //         const allCategoryRes = await allCategoryReq.json()
  //         console.log('All detail Category data :',allCategoryRes)

  //         const categoryForNewPType = await fetch(`${ip}/api/mstcategories?populate=*&filters[CategoryName][$eqi]=${CategoryName}`)
  //         const categoryForNewPtypeResponse = await categoryForNewPType.json();

  //         const MatchingProductType = allCategoryRes.data.filter(
  //           item => item.attributes.CategoryName.toLowerCase() === categoryForNewPtypeResponse.data[0].attributes.CategoryName.toLowerCase()
  //         )
  //         console.log('Matching Product Type Name :',MatchingProductType)

  //         if (!MatchingProductType) {

  //             const CategoryDataRequest = await fetch(
  //             `${ip}/api/mstcategories?populate=*&filters[CategoryName][$eq]=${ProductTypeName}`
  //             );
  //             const CategoryDataResponse = await CategoryDataRequest.json();

  //             console.log("CategoryDataResponse Data :", CategoryDataResponse)
  //             const formData = new FormData();
  //             formData.append(
  //               'data',
  //               JSON.stringify({
  //                 ProductTypeName,
  //                 ProductTypeCode: nextProductTypeCode,
  //                 Categorycode: CategoryDataResponse.data[0].attributes.CategoryCode,
  //                 dis: 'Continue'
  //               })
  //             );

  //             const response = await fetch(`${ip}/api/mstproducttypes`, {
  //               method: 'POST',
  //               body: formData
  //             });

  //             const data = await response.json();
  //             console.log(data);
  //             fetchData2();

  //         } else {
  //           console.error('Category not found for the given Categorycode.');
  //         }
  //       } catch (error) {
  //         console.error('Error while processing selectedPtype:', error);
  //       }
  //       updatedRows[index].ProductTypeName = ProductTypeName;
  //       setProductTypeDataPerRow(prevState => ({
  //         ...prevState,
  //         [index]: [
  //           {
  //             label: updatedRows[index].ProductTypeName,
  //             value: updatedRows[index].ProductTypeCode
  //           }
  //         ]
  //       }));
  //       updatedRows[index].ProductTypeCode = selectedPtype.value;
  //       }

  //   }

  //   // After handling both changes, update the state with the modified rows
  //   CategoryCode = updatedRows[index].CategoryCode;
  //   setRows(prevRows => {
  //     const newRows = [...prevRows];

  //     newRows[index] = updatedRows[index];
  //     console.log('saving');
  //     console.log(newRows);
  //     return newRows;
  //   });
  //   setIsLoading(false);
  // };
  const handleChange2 = async (index, { CategoryName, CategoryCode, ProductTypeName }) => {
    setIsLoading(true);
    // Clone the current rows state to avoid mutating it directly
    const updatedRows = [...rows];

    // If the row at the given index does not exist, create an empty row and append it
    if (!updatedRows[index]) {
      updatedRows[index] = createEmptyRow(index);
    }

    // Handle CategoryName update
    if (CategoryName.trim() !== '') {
      // console.log('Handling CategoryName');
      const allCategory = await fetch(
        `${ip}/api/mstcategories?populate=*&pagination[pageSize]=10000`
      );
      const allCategoryRes = await allCategory.json();

      let selectedCategory = allCategoryRes.data.filter(
        item => item.attributes.CategoryName.toLowerCase() === CategoryName.toLowerCase()
      );
      console.log('allCategoryRes', allCategoryRes);
      console.log('CategoryName', CategoryName);
      console.log('selectedCategory', selectedCategory);

      const searchResponse1 = await fetch(`${ip}/api/mstcategories?fields[0]=CategoryName`);
      const searchData1 = await searchResponse1.json();
      const nextCategoryCode = generatecategorycode(searchData1.meta.pagination.total);

      const searchResponse2 = await fetch(`${ip}/api/mstproducttypes?fields[0]=ProductTypeName`);
      const searchData2 = await searchResponse2.json();
      const nextProductTypeCode = generateptypecode(searchData2.meta.pagination.total);

      if (selectedCategory.length <= 0) {
        // console.log('entered not if catgory');
        await fetch(`${ip}/api/mstcategories`, {
          method: 'POST',
          body: JSON.stringify({
            data: {
              CategoryName,
              CategoryCode: nextCategoryCode,
              dis: 'Continue'
            }
          }),
          headers: { 'Content-Type': 'application/json' }
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
            fetchData(); // Fetch updated data
            // updatedRows[index].CategoryCode = nextCategoryCode;
          });

        const formData = new FormData();
        formData.append(
          'data',
          JSON.stringify({
            ProductTypeName,
            ProductTypeCode: nextProductTypeCode,
            Categorycode: nextCategoryCode,
            dis: 'Continue'
          })
        );
        const response = await fetch(`${ip}/api/mstproducttypes`, {
          method: 'POST',
          body: formData
        });

        const data = await response.json();
        console.log(data);
        fetchData2();

        updatedRows[index].CategoryName = CategoryName;
        updatedRows[index].CategoryCode = nextCategoryCode;
        updatedRows[index].ProductTypeName = ProductTypeName;
        updatedRows[index].ProductTypeCode = nextProductTypeCode;

        setProductTypeDataPerRow(prev => ({
          ...prev,
          [index]: [{ label: ProductTypeName, value: ProductTypeName }]
        }));

        setSelectedCategoryCode(nextCategoryCode);
      } else {
        console.log('categoryCode', selectedCategory);
        const categoryCode = selectedCategory[0].attributes.CategoryCode;
        const searchCategory = await fetch(
          `${ip}/api/mstproducttypes?populate=*&filters[Categorycode][$eqi]=${categoryCode}&pagination[pageSize]=10000`
        );
        const searchCategoryRes = await searchCategory.json();
        console.log('searchCategoryRes', searchCategoryRes);

        const existPType = searchCategoryRes.data.filter(
          item => item.attributes.ProductTypeName.toLowerCase() === ProductTypeName.toLowerCase()
        );
        if (existPType.length === 0) {
          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              ProductTypeName,
              ProductTypeCode: nextProductTypeCode,
              Categorycode: categoryCode,
              dis: 'Continue'
            })
          );
          const response = await fetch(`${ip}/api/mstproducttypes`, {
            method: 'POST',
            body: formData
          });

          const data = await response.json();
          console.log(data);
          fetchData2();
        }
        updatedRows[index].CategoryName = CategoryName;
        updatedRows[index].CategoryCode = categoryCode;
        updatedRows[index].ProductTypeName = ProductTypeName;
        updatedRows[index].ProductTypeCode = nextProductTypeCode;
        setProductTypeDataPerRow(prev => ({
          ...prev,
          [index]: searchCategoryRes.data.map(item => ({
            label: item.attributes.ProductTypeName,
            value: item.attributes.ProductTypeName
          }))
        }));
      }

      fetchData();
      setSelectedCategoryCode(selectedCategory ? selectedCategory.value : '');
    }
    // After handling both changes, update the state with the modified rows
    CategoryCode = updatedRows[index].CategoryCode;
    setRows(prevRows => {
      const newRows = [...prevRows];

      newRows[index] = updatedRows[index];
      console.log('saving');
      console.log(newRows);
      return newRows;
    });
    setIsLoading(false);
  };

  // const handleChange3 = async (index, { FinishName }) => {
  //   // Clone the current rows state to avoid mutating it directly
  //   const updatedRows = [...rows];
  //   // If the row at the given index does not exist, create an empty row and append it
  //   if (!updatedRows[index]) {
  //     updatedRows[index] = createEmptyRow(index);
  //   }
  //   // Handle CategoryName update
  //   if (FinishName) {
  //     // console.log('Handling CategoryName');
  //     let selectedCategory = finishdata.find(
  //       item => item.label.toLowerCase() === FinishName.toLowerCase()
  //     );
  //     const searchResponse = await fetch(`${ip}/api/mstfinishes?fields[0]=FinishName`);
  //     const searchData = await searchResponse.json();
  //     const nextCategoryCode = generatefinishcode(searchData.meta.pagination.total);
  //     if (!selectedCategory) {
  //       // console.log('entered not if catgory');
  //       fetch(`${ip}/api/mstfinishes?filters[FinishName][$eq]=${FinishName}`)
  //         .then(response => response.json())
  //         .then(searchData => {
  //           if (searchData.data.length === 0) {
  //             // If not found, make the POST request
  //             return fetch(`${ip}/api/mstfinishes`, {
  //               method: 'POST',
  //               body: JSON.stringify({
  //                 data: {
  //                   FinishName,
  //                   FinishCode: nextCategoryCode,
  //                   dis: 'Continue'
  //                 }
  //               }),
  //               headers: { 'Content-Type': 'application/json' }
  //             })
  //               .then(response => response.json())
  //               .then(data => {
  //                 console.log(data);
  //                 fetchData(); // Fetch updated data
  //               });
  //           } else {
  //             selectedCategory = true;
  //             // Category exists
  //             // console.log(`Category ${CategoryName} already exists.${searchData.data[0].attributes.CategoryCode}`);
  //             updatedRows[index].FinishCode = searchData.data[0].attributes.FinishCode;
  //           }
  //         })
  //         .catch(error => {
  //           console.error('Error:', error);
  //         });
  //     } else {
  //       updatedRows[index].FinishCode = selectedCategory.value;
  //     }
  //     updatedRows[index].FinishName = FinishName;
  //   }
  //   FinishCode = updatedRows[index].FinishCode;
  //   setRows(prevRows => {
  //     const newRows = [...prevRows];
  //     newRows[index] = updatedRows[index];
  //     console.log('saving');
  //     console.log(newRows);
  //     return newRows;
  //   });
  // };

  // const handleChange3 = async (index, { FinishName , FinishCode}) => {
  //   // Clone the current rows state
  //   const updatedRows = [...rows];

  //   // Ensure the row exists
  //   if (!updatedRows[index]) {
  //     updatedRows[index] = createEmptyRow(index);
  //   }

  //   if (FinishName) {
  //     // Find selected category locally
  //     let selectedCategory = finishdata.find(
  //       item => item.label.toLowerCase() === FinishName.toLowerCase()
  //     );

  //     if (!selectedCategory) {
  //       try {
  //         // Fetch if FinishName exists in the API
  //         const existingResponse = await fetch(
  //           `${ip}/api/mstfinishes?filters[FinishName][$eq]=${FinishName}`
  //         );
  //         const existingData = await existingResponse.json();

  //         if (existingData.data.length === 0) {
  //           // Fetch total records for generating FinishCode
  //           const metaResponse = await fetch(
  //             `${ip}/api/mstfinishes?fields[0]=FinishName`
  //           );
  //           const metaData = await metaResponse.json();
  //           const nextCategoryCode = generatefinishcode(metaData.meta.pagination.total);

  //           // Create new FinishName
  //           const createResponse = await fetch(`${ip}/api/mstfinishes`, {
  //             method: 'POST',
  //             body: JSON.stringify({
  //               data: {
  //                 FinishName,
  //                 FinishCode: nextCategoryCode,
  //                 dis: 'Continue',
  //               },
  //             }),
  //             headers: { 'Content-Type': 'application/json' },
  //           });
  //           const createdData = await createResponse.json();

  //           updatedRows[index].FinishCode = createdData.data.attributes.FinishCode;
  //           fetchData(); // Fetch updated data if required
  //         } else {
  //           // Use the existing FinishCode
  //           updatedRows[index].FinishCode = existingData.data[0].attributes.FinishCode;
  //         }
  //       } catch (error) {
  //         console.error('Error handling FinishName:', error);
  //       }
  //     } else {
  //       // Use local FinishCode
  //       updatedRows[index].FinishCode = selectedCategory.value;
  //     }

  //     // Update the row FinishName
  //     updatedRows[index].FinishName = FinishName;
  //   }

  //   // Update state
  //   setRows(prevRows => {
  //     const newRows = [...prevRows];
  //     newRows[index] = updatedRows[index];
  //     return newRows;
  //   });
  // };

  const calculateCBM = (SizeUnit, Length, Width, Height) => {
    if (SizeUnit !== '') {
      const unitConversionFactor = SizeUnit === 'cm' ? 1 / 1000000 : 1 / 61023;
      const productcbm3 = Length * Width * Height * unitConversionFactor;
      return parseFloat(productcbm3).toFixed(4);
    }
    return 0;
  };
  const normalize = str => (str || '').trim().toLowerCase();

  const handleChange = async (index, inputName, value) => {
    setIsLoading(true);
    // Create a function to generate an empty row with the same schema

    // Clone the current rows state to avoid mutating it directly
    const updatedRows = [...rows];

    // If the row at the given index does not exist, create an empty row and append it
    if (!updatedRows[index]) {
      updatedRows[index] = createEmptyRow(index);
    }

    // Proceed with handling the input change as usual
    if (inputName === 'ProductId') {
      const newProductId = value;

      // Get the category for this row
      const selectedCategory = updatedRows[index].CategoryName
        ? categorydata.find(
            item => normalize(item.label) === normalize(updatedRows[index].CategoryName)
          )
        : null;

      if (aliasauto === 'Cate.Shortname + Manual' && selectedCategory) {
        const prefix = `${selectedCategory.sname}-`;

        // Allow editing only the numeric part after the dash
        if (newProductId.startsWith(prefix)) {
          const editablePart = newProductId.substring(prefix.length);

          if (editablePart.length >= 0) {
            updatedRows[index].ProductId = newProductId;
            setPendingProductId(newProductId);
          } else {
            toaster.push(
              <Message type="warning">
                Only the numeric part of the ProductId can be edited.
              </Message>
            );
          }
        } else {
          toaster.push(
            <Message type="warning">You can only edit the number part after "{prefix}"</Message>
          );
        }
      } else {
        // For Manual mode or other modes, allow full edit
        updatedRows[index].ProductId = newProductId;
        setPendingProductId(newProductId);
      }
    } else if (inputName === 'CategoryName') {
      let selectedCategory = categorydata.find(item => normalize(item.label) === normalize(value));

      const nextCategoryCode = generatecategorycode(categorymeta.pagination.total + index);
      if (aliasauto == 'Manual') {
        // If aliasauto is false, update only CategoryName and CategoryCode

        updatedRows[index].CategoryName = value;

        updatedRows[index].CategoryCode = selectedCategory ? selectedCategory.value : '';
        setSelectedCategoryCode(selectedCategory ? selectedCategory.value : '');
      } else {
        // If aliasauto is true, fetch products for the selected category
        if (selectedCategory) {
          fetch(`${ip}/api/products?filters[CategoryCode][$eq]=${selectedCategory.value}`)
            .then(response => response.json())
            .then(json => {
              const products = json.meta?.pagination?.total || 0;
              // const totalProductsInCategory = products.length;
              console.log(selectedCategory);
              // Construct ProductId based on sname and total products in the category
              const productId = selectedCategory.sname
                ? `${selectedCategory.sname}-${products + 1}`
                : `${products + 1}`;

              // Update state
              updatedRows[index].ProductId = productId;

              updatedRows[index].CategoryName = value;

              updatedRows[index].CategoryCode = selectedCategory.value;
            })
            .catch(error => {
              console.error('Error fetching products:', error);
            });
        }
      }
      if (!selectedCategory) {
        try {
          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              CategoryName: value,
              CategoryCode: nextCategoryCode,
              dis: 'Continue'
            })
          );
          const response = await fetch(`${ip}/api/mstcategories`, {
            method: 'POST',
            body: formData
          });
          const data = await response.json();
          console.log(data);
          fetchData(); // Fetch updated category data
        } catch (error) {
          console.error('Error adding new category:', error);
        }
        updatedRows[index].CategoryCode = nextCategoryCode;
        setSelectedCategoryCode(nextCategoryCode);
      } else {
        updatedRows[index].CategoryCode = selectedCategory.value;
      }
      updatedRows[index].CategoryName = value;

      setSelectedCategoryCode(selectedCategory ? selectedCategory.value : '');

      if (selectedCategory) {
        try {
          const response = await fetch(
            `${ip}/api/mstproducttypes?populate=*&pagination[page]=1&filters[Categorycode][$eq]=${selectedCategory.value}`
          );
          const json = await response.json();
          const processedData = json.data.map(item => ({
            label: item.attributes.ProductTypeName,
            value: item.attributes.ProductTypeCode
          }));

          // setProductTypeDataPerRow(prevState => ({
          //   ...prevState,
          //   [index]: processedData
          // }));
          setProductTypeDataPerRow(prevState => ({
            ...prevState,
            [updatedRows[index].id]: processedData // ✅ id को key बनाया
          }));
        } catch (error) {
          console.error('Error fetching product type data:', error);
        }
      } else {
        setProductTypeDataPerRow(prevState => ({
          ...prevState,
          [updatedRows[index].id]: []
        }));
      }
    } else if (inputName === 'ProductTypeName') {
      console.log('ProductTypeName', value);
      let selectedPtype = productypedata.find(
        item => item.label.toLowerCase() === value.toLowerCase()
      );
      if (!selectedPtype) {
        selectedPtype = updatedRows.find(
          item => item.ProductTypeName.toLowerCase() === value.toLowerCase()
        );
      }
      const nextProductTypeCode = generateptypecode(productypemeta.pagination.total + index + 1);

      if (!selectedPtype) {
        try {
          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              ProductTypeName: value,
              ProductTypeCode: nextProductTypeCode,
              Categorycode: updatedRows[index].CategoryCode,
              dis: 'Continue'
            })
          );
          const response = await fetch(`${ip}/api/mstproducttypes`, {
            method: 'POST',
            body: formData
          });
          const data = await response.json();
          console.log(data);
          fetchData2(); // Fetch updated product type data
        } catch (error) {
          console.error('Error adding new product type:', error);
        }
      } else {
        updatedRows[index].ProductTypeCode = selectedPtype.value;
      }
      updatedRows[index].ProductTypeName = value;
      setProductTypeDataPerRow(prev => ({
        ...prev,
        [updatedRows[index].id]: [
          {
            label: value,
            value: updatedRows[index].ProductTypeCode || ''
          }
        ]
      }));
    } else if (inputName === 'FinishName') {
      if (typeof value === 'string' && value !== '') {
        let selectedfinish = finishdata.find(
          item => item.label.toLowerCase().trim() === value.toLowerCase().trim()
        );
        const nextCategoryCode = generatefinishcode(finishmeta.pagination.total + index + 1);
        if (!selectedfinish) {
          const searchResponse = await fetch(
            `${ip}/api/mstfinishes?filters[FinishName][$eq]=${value}`
          );
          const searchData = await searchResponse.json();
          try {
            if (searchData.data.length === 0) {
              const formData = new FormData();
              formData.append(
                'data',
                JSON.stringify({
                  FinishName: value,
                  FinishCode: nextCategoryCode,
                  dis: 'Continue'
                })
              );

              // Send the POST request to create a new color
              const response = await fetch(`${ip}/api/mstfinishes`, {
                method: 'POST',
                body: formData
              });
              const data = await response.json();
              console.log(data);
            } else {
              console.log('FinishName already exists');
            }
          } catch (error) {
            console.error('Error adding new finish:', error);
          }
          updatedRows[index].FinishCode = nextCategoryCode;
        } else {
          updatedRows[index].FinishCode = selectedfinish.value;
        }
        updatedRows[index].FinishName = value;
      }
    } else if (inputName === 'ColorName') {
      if (typeof value === 'string' && value !== '') {
        let selectedColor = colordata.find(
          item => item.label.toLowerCase().trim() === value.toLowerCase().trim()
        );
        const nextColorCode = generatecolorcode(colormeta.pagination.total + index);

        if (!selectedColor) {
          try {
            // First, check if the ColorName already exists
            const searchResponse = await fetch(
              `${ip}/api/mstcolors?filters[ColorName][$eq]=${value}`
            );
            const searchData = await searchResponse.json();

            // If no data exists with the same ColorName, proceed with POST request
            if (searchData.data.length === 0) {
              const formData = new FormData();
              formData.append(
                'data',
                JSON.stringify({
                  ColorName: value,
                  ColorCode: nextColorCode,
                  dis: 'Continue'
                })
              );

              // Send the POST request to create a new color
              const response = await fetch(`${ip}/api/mstcolors`, {
                method: 'POST',
                body: formData
              });
              const data = await response.json();
              console.log(data);
            } else {
              console.log('ColorName already exists');
            }
          } catch (error) {
            console.error('Error adding new color:', error);
          }
        } else {
          updatedRows[index].ColorCode = selectedColor.value;
        }
        updatedRows[index].ColorName = value;
      }
    } else if (inputName === 'HSNCode') {
      if (typeof value === 'string' && value !== '') {
        let selectedHSN = hsndata.find(item => item.label.trim() == value.trim());

        if (!selectedHSN) {
          try {
            // First, check if the hscode already exists
            const searchResponse = await fetch(
              `${ip}/api/msthscodes?filters[hscode][$eq]=${value}`
            );
            const searchData = await searchResponse.json();

            // If no data exists with the same hscode, proceed with POST request
            if (searchData.data.length === 0) {
              const formData = new FormData();
              formData.append(
                'data',
                JSON.stringify({
                  hscode: value,
                  dis: 'Continue'
                })
              );

              // Send the POST request to create a new HSCode
              const response = await fetch(`${ip}/api/msthscodes`, {
                method: 'POST',
                body: formData
              });
              const data = await response.json();
              console.log(data);

              // Fetch the updated HSCode data
              // fetchData6();
            } else {
              console.log('HSCode already exists');
            }
          } catch (error) {
            console.error('Error adding new HSCode:', error);
          }
        } else {
          updatedRows[index].HSNCode = selectedHSN.value;
        }
        updatedRows[index].HSNCode = value;
      }
    } else if (inputName === 'Length') {
      updatedRows[index].Length = value;
      updatedRows[index].cbm = calculateCBM(
        updatedRows[index].SizeUnit,
        updatedRows[index].Length,
        updatedRows[index].Width,
        updatedRows[index].Height
      );
    } else if (inputName === 'Width') {
      updatedRows[index].Width = value;
      updatedRows[index].cbm = calculateCBM(
        updatedRows[index].SizeUnit,
        updatedRows[index].Length,
        updatedRows[index].Width,
        updatedRows[index].Height
      );
    } else if (inputName === 'Height') {
      updatedRows[index].Height = value;
      updatedRows[index].cbm = calculateCBM(
        updatedRows[index].SizeUnit,
        updatedRows[index].Length,
        updatedRows[index].Width,
        updatedRows[index].Height
      );
    } else if (inputName === 'SizeUnit') {
      updatedRows[index].SizeUnit = value;
      updatedRows[index].cbm = calculateCBM(
        updatedRows[index].SizeUnit,
        updatedRows[index].Length,
        updatedRows[index].Width,
        updatedRows[index].Height
      );
    } else if (inputName === 'HSNCode') {
    } else if (
      inputName.startsWith('Carton_') ||
      inputName === 'CartonType' ||
      inputName === 'ProductCode'
    ) {
      if (!updatedRows[index].Packaging || updatedRows[index].Packaging.length === 0) {
        updatedRows[index].Packaging = [
          {
            CartonType: '',
            ProductCode: '',
            Carton_Unit: '',
            Carton_Length: 0,
            Carton_Width: 0,
            Carton_Thick: 0,
            Carton_CBM: 0,
            Carton_PCS: 0,
            Carton_CBMperpc: 0,
            Carton_GrsWt: 0
          }
        ];
      }

      updatedRows[index].Packaging[0][inputName] = value;

      // Auto calculate CBM and CBM per piece when packaging dimensions change
      if (
        inputName === 'Carton_Length' ||
        inputName === 'Carton_Width' ||
        inputName === 'Carton_Thick' ||
        inputName === 'Carton_Unit' ||
        inputName === 'Carton_PCS'
      ) {
        const pack = updatedRows[index].Packaging[0];

        // Recalculate CBM
        pack.Carton_CBM = calculatePackagingCBM(
          pack.Carton_Unit,
          pack.Carton_Length,
          pack.Carton_Width,
          pack.Carton_Thick
        );

        // Recalculate CBM per piece
        pack.Carton_CBMperpc =
          pack.Carton_PCS > 0 ? parseFloat((pack.Carton_CBM / pack.Carton_PCS).toFixed(4)) : 0;
      }
    } else {
      updatedRows[index][inputName] = value;
    }

    // After handling the change, update the state with the modified rows
    setRows(prevRows => {
      const newRows = [...prevRows];
      newRows[index] = updatedRows[index];
      return newRows;
    });

    // }
    setIsLoading(false);
  };

  const calculatePackagingCBM = (
    unit: string,
    length: number,
    width: number,
    thick: number
  ): number => {
    if (!unit || !length || !width || !thick) return 0;

    let factor = 0;

    switch (unit.toLowerCase()) {
      case 'cm':
        factor = 1 / 1000000; // Convert cm³ to m³
        break;
      case 'mm':
        factor = 1 / 1000000000; // Convert mm³ to m³
        break;
      case 'm':
        factor = 1; // Already in m³
        break;
      case 'inch':
        factor = 0.000016387; // Convert cubic inches to m³
        break;
      default:
        factor = 1 / 1000000; // default assume cm
    }

    const totalCBM = length * width * thick * factor;
    return parseFloat(totalCBM.toFixed(4));
  };

  const [name, setName] = useState('');
  const handleImageUpload = (fileList, rowIndex) => {
    if (fileList.length > 0) {
      const file = fileList[0];
      const allowedExtensions = ['jpg', 'jpeg'];
      const fileExtension = file.name.split('.').pop().toLowerCase();

      setName(file.name);

      if (allowedExtensions.includes(fileExtension)) {
        const updatedRows = [...rows];
        updatedRows[rowIndex] = {
          ...updatedRows[rowIndex],
          CoverImage: file.blobFile
        };
        setRows(updatedRows);

        // setRows({
        //   ...rows,
        //   CoverImage: file.blobFile
        // });

        toaster.push(
          <Message showIcon type="success">
            Image Upload Successfully
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        toaster.push(
          <Message showIcon type="error">
            Please change the image format to jpg/jpeg
          </Message>,
          { placement: 'topCenter' }
        );
      }
    }
  };

  // const handleImageUpload = (fileList, rowIndex) => {
  //   if (fileList.length > 0) {
  //     const file = fileList[0];
  //     const fileExtension = file.name.split('.').pop().toLowerCase();
  //     console.log("File extension:", fileExtension);

  //      if (fileExtension === 'jpeg' || fileExtension === 'jpg') {

  //       console.log("JPEG or JPG file detected. Proceeding with upload.");

  //       const updatedRows = [...rows];
  //       updatedRows[rowIndex] = {
  //         ...updatedRows[rowIndex],
  //         // CoverImage: file.blobFile
  //       };
  //       setRows(updatedRows);

  //       toaster.push(
  //         <Message showIcon type="success">
  //           Image Upload Successfully
  //         </Message>,
  //         { placement: 'topCenter' }
  //       );
  //     } else {
  //       toaster.push(
  //         <Message showIcon type="error">
  //           Please upload only JPEG or JPG files
  //         </Message>,
  //         { placement: 'topCenter' }
  //       );
  //     }
  //   }
  // };

  const [open, setOpen] = React.useState(false);
  const [size1, setSize1] = React.useState();
  const handleOpen = value => {
    setSize1(value);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const [selectAll, setSelectAll] = React.useState(false);

  const allcheckbox = check => {
    console.log(check);

    setImage(check ? true : false);
    setCategory(check ? true : false);
    setProductype(check ? true : false);
    setSellingPrice(check ? true : false);
    setMoq(check ? true : false);
    setDescription(check ? true : false);
    setSearchKeyword(check ? true : false);
    setProductID(check ? true : false);
    setProductname(check ? true : false);
    setFinish(check ? true : false);
    setNetWeight(check ? true : false);
    setGrossweight(check ? true : false);
    setProductCost(check ? true : false);
    setHsn(check ? true : false);
    setSellingpriceU(check ? true : false);
    setColor(check ? true : false);
    setMadeby(check ? true : false);
    setBuyername(check ? true : false);
    setBuyersku(check ? true : false);
    setLength(check ? true : false);
    setWidth(check ? true : false);
    setHeight(check ? true : false);
    setCbm(check ? true : false);
    setSellingpriceC(check ? true : false);
    setSize(check ? true : false);
    setProductDesigner(check ? true : false);
  };

  const handleimageCheckbox = () => {
    setImage(!image);
  };
  const handlecategoryCheckbox = () => {
    setCategory(!category);
  };
  const handlesubCategoryCheckbox = () => {
    setProductype(!Productype);
  };
  const handlesellingPriceCheckbox = () => {
    setSellingPrice(!sellingPrice);
  };
  const handlemoqCheckbox = () => {
    setMoq(!moq);
  };
  const handledescriptionCheckbox = () => {
    setDescription(!description);
  };
  const handlesearchKeywordCheckbox = () => {
    setSearchKeyword(!searchKeyword);
  };
  const handlenameCheckbox = () => {
    setProductID(!productID);
  };
  const handleproductionTimeCheckbox = () => {
    setProductname(!productname);
  };
  const handleremarksCheckbox = () => {
    setFinish(!finish);
  };
  const handlesamplingTimeCheckbox = () => {
    setNetWeight(!netWeight);
  };
  const handleproductionTechCheckbox = () => {
    setGrossweight(!grossweight);
  };
  const handleproductCostCheckbox = () => {
    setProductCost(!productCost);
  };
  const handlepriceFromeVendorCheckbox = () => {
    setHsn(!hsn);
  };
  const handledispatchDataCheckbox = () => {
    setSellingpriceU(!sellingpriceU);
  };
  const handlecolorCheckbox = () => {
    setColor(!color);
  };
  const handleseasonCheckbox = () => {
    setSellingpriceC(!sellingpriceC);
  };
  const handleexclusiveForCheckbox = () => {
    setProductDesigner(!productDesigner);
  };
  const handlesizeCheckbox = () => {
    setSize(!size);
  };
  const handleshapeCheckbox = () => {
    setMadeby(!madeby);
  };
  const handlevendornameCheckbox = () => {
    setBuyername(!buyername);
  };
  const handlethemeCheckbox = () => {
    setBuyersku(!buyersku);
  };
  const handlelenghtCheckbox = () => {
    setLength(!length);
  };
  const handlewidthCheckbox = () => {
    setWidth(!width);
  };
  const handleheightCheckbox = () => {
    setHeight(!height);
  };
  const handlecbmCheckbox = () => {
    setCbm(!cbm);
  };

  //category data fetch start
  const [categorydata, setCategorydata] = React.useState([]);
  const [categorymeta, setCategorymeta] = useState<MetaData>();
  const [isLoadingc, setIsLoadingc] = React.useState(false);

  useEffect(() => {
    fetchData();
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const fetchData = async () => {
    if (isLoadingc) {
      return;
    }
    setIsLoadingc(true);
    try {
      const response = await fetch(
        `${ip}/api/mstcategories?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const responsemeta = await fetch(
        `${ip}/api/mstcategories?populate=*&publicationState=preview`
      );
      const jsonmeta = await responsemeta.json();
      const allData = [];

      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstcategories?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.CategoryName,
          value: item.attributes.CategoryCode,
          sname: item.attributes.ShortName
        }));
        allData.push(...processedData);
      }
      // allData.sort((a, b) => a.label.localeCompare(b.label));
      allData.sort((a, b) => {
        const labelA = (a.label || '').toString().toLowerCase();
        const labelB = (b.label || '').toString().toLowerCase();
        return labelA.localeCompare(labelB);
      });
      setCategorydata(allData);
      setIsLoadingc(false);
      setCategorymeta(jsonmeta.meta);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
    if (scrollHeight - (scrollTop + clientHeight) < 100) {
      // You can adjust the threshold
      // Load more data
      // In this case, we don't need to fetch more data as we have already fetched all pages upfront.
      // We can simply show more items from the `data123` array.
    }
  };
  //category data fetch end
  // const fetchDatap = async () => {

  //   let url = `${ip}/api/mstproducttypes?populate=*&pagination[page]=1&sort[0]=id`;

  //   const pageResponse = await fetch(url);
  //   const pageJson = await pageResponse.json();
  //   const allData = [];
  //   for (let page = 1; page <= pageJson.meta.pagination.pageCount; page++) {
  //     const pageResponse = await fetch(url);
  //     const pageJson = await pageResponse.json();
  //     allData.push(...pageJson.data);
  //   }
  //   setProductTypedata(allData);
  // };
  //product type data fetch start
  const [productypedata, setProductypedata] = React.useState([]);
  const [productypemeta, setProductypemeta] = useState<MetaData>();
  const [isLoadingpro, setIsLoadingpro] = React.useState(false);

  useEffect(() => {
    fetchData2();

    window.addEventListener('scroll', handleScrollpro);
    return () => {
      window.removeEventListener('scroll', handleScrollpro);
    };
  }, []);
  const fetchData2 = async () => {
    if (isLoadingpro) {
      return;
    }
    setIsLoadingpro(true);
    try {
      const response = await fetch(`${ip}/api/mstproducttypes?populate=*&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstproducttypes?populate=*&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.ProductTypeName,
          value: item.attributes.ProductTypeCode,
          categoryCode: item.attributes.Categorycode
        }));
        allData.push(...processedData);
      }
      const responsemeta = await fetch(
        `${ip}/api/mstproducttypes?populate=*&publicationState=preview`
      );
      const jsonmeta = await responsemeta.json();
      // allData.sort((a, b) => a.label.localeCompare(b.label));
      // allData.sort((a, b) => {
      //   const labelA = (a.label || '').toString().toLowerCase();
      //   const labelB = (b.label || '').toString().toLowerCase();
      //   return labelA.localeCompare(labelB);
      // });
      setProductypedata(allData);
      setIsLoadingpro(false);
      setProductypemeta(jsonmeta.meta);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const handleScrollpro = () => {
    const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
    if (scrollHeight - (scrollTop + clientHeight) < 100) {
      // You can adjust the threshold
      // Load more data
      // In this case, we don't need to fetch more data as we have already fetched all pages upfront.
      // We can simply show more items from the `data123` array.
    }
  };
  //product type data fetch end

  //Collection type data fetch start
  const [collectiondata, setCollectiondata] = React.useState([]);
  const [isLoadingcoll, setIsLoadingcoll] = React.useState(false);
  useEffect(() => {
    fetchData3();
    window.addEventListener('scroll', handleScrollcoll);
    return () => {
      window.removeEventListener('scroll', handleScrollcoll);
    };
  }, []);
  const fetchData3 = async () => {
    if (isLoadingcoll) {
      return;
    }
    setIsLoadingcoll(true);
    try {
      const response = await fetch(`${ip}/api/mstmaterialcollections?&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstmaterialcollections?&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.MatCollectionName,
          value: item.attributes.MatCollectionCode
        }));
        allData.push(...processedData);
      }
      setCollectiondata(allData);
      setIsLoadingcoll(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const handleScrollcoll = () => {
    const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
    if (scrollHeight - (scrollTop + clientHeight) < 100) {
      // You can adjust the threshold
      // Load more data
      // In this case, we don't need to fetch more data as we have already fetched all pages upfront.
      // We can simply show more items from the `data123` array.
    }
  };
  //Collection type data fetch end
  //Finish type data fetch start
  const [finishdata, setFinishdata] = React.useState([]);
  const [finishmeta, setFinishmeta] = useState<MetaData>();
  const [isLoadingfin, setIsLoadingfin] = React.useState(false);
  useEffect(() => {
    fetchData4();
    window.addEventListener('scroll', handleScrollfin);
    return () => {
      window.removeEventListener('scroll', handleScrollfin);
    };
  }, []);

  // const fetchData4 = async () => {
  //   if (isLoadingfin) {
  //     return;
  //   }
  //   setIsLoadingfin(true);
  //   try {
  //     const response = await fetch(
  //       `${ip}/api/mstfinishes?&pagination[page]=1&filters[dis][$ne]=Discontinue`
  //     );
  //     const json = await response.json();
  //     const allData = [];
  //     for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
  //       const pageResponse = await fetch(
  //         `${ip}/api/mstfinishes?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
  //       );
  //       const pageJson = await pageResponse.json();
  //       const processedData = pageJson.data.map(item => ({
  //         label: item.attributes.FinishName,
  //         value: item.attributes.FinishCode
  //       }));
  //       allData.push(...processedData);
  //     }
  //     const responsemeta = await fetch(`${ip}/api/mstfinishes?populate=*&publicationState=preview`);
  //     const jsonmeta = await responsemeta.json();
  //     allData.sort((a, b) => a.label.localeCompare(b.label));
  //     setFinishdata(allData);
  //     setIsLoadingfin(false);
  //     setFinishmeta(jsonmeta.meta);
  //   } catch (error) {
  //     console.error('Error fetching category data:', error);
  //   }
  // };

  const fetchData4 = async () => {
    if (isLoadingfin) {
      return;
    }
    setIsLoadingfin(true);
    try {
      const response = await fetch(
        `${ip}/api/mstfinishes?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstfinishes?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();

        // Filter out items with null FinishName and map the data
        const processedData = pageJson.data
          .filter(item => item.attributes.FinishName !== null) // Filter out null values
          .map(item => ({
            label: item.attributes.FinishName,
            value: item.attributes.FinishCode
          }));

        allData.push(...processedData);
      }
      const responsemeta = await fetch(`${ip}/api/mstfinishes?populate=*&publicationState=preview`);
      const jsonmeta = await responsemeta.json();
      allData.sort((a, b) => a.label.localeCompare(b.label));
      setFinishdata(allData);
      setIsLoadingfin(false);
      setFinishmeta(jsonmeta.meta);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const handleScrollfin = () => {
    const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
    if (scrollHeight - (scrollTop + clientHeight) < 100) {
      // You can adjust the threshold
      // Load more data
      // In this case, we don't need to fetch more data as we have already fetched all pages upfront.
      // We can simply show more items from the `data123` array.
    }
  };
  //Finish type data fetch end
  //color type data fetch start
  const [colordata, setColordata] = React.useState([]);
  const [colormeta, setColormeta] = useState<MetaData>();
  const [isLoadingcolor, setIsLoadingcolor] = React.useState(false);
  useEffect(() => {
    fetchData5();
    window.addEventListener('scroll', handleScrollcolor);
    return () => {
      window.removeEventListener('scroll', handleScrollcolor);
    };
  }, []);
  const fetchData5 = async () => {
    if (isLoadingcolor) {
      return;
    }
    setIsLoadingcolor(true);
    try {
      const response = await fetch(
        `${ip}/api/mstcolors?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstcolors?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.ColorName,
          value: item.attributes.ColorCode
        }));
        allData.push(...processedData);
      }
      const responsemeta = await fetch(`${ip}/api/mstcolors?populate=*&publicationState=preview`);
      const jsonmeta = await responsemeta.json();
      allData.sort((a, b) => a.label.localeCompare(b.label));
      setColordata(allData);
      setIsLoadingcolor(false);
      setColormeta(jsonmeta.meta);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const handleScrollcolor = () => {
    const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
    if (scrollHeight - (scrollTop + clientHeight) < 100) {
      // You can adjust the threshold
      // Load more data
      // In this case, we don't need to fetch more data as we have already fetched all pages upfront.
      // We can simply show more items from the `data123` array.
    }
  };
  //color type data fetch end
  //hsn type data fetch start
  const [hsndata, setHsndata] = React.useState([]);
  const [isLoadinghsn, setIsLoadinghsn] = React.useState(false);
  useEffect(() => {
    fetchData6();
    window.addEventListener('scroll', handleScrollhsn);
    return () => {
      window.removeEventListener('scroll', handleScrollhsn);
    };
  }, []);
  const fetchData6 = async () => {
    if (isLoadinghsn) {
      return;
    }
    setIsLoadinghsn(true);
    try {
      const response = await fetch(
        `${ip}/api/msthscodes?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/msthscodes?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.hscode,
          value: item.attributes.hscode
        }));
        allData.push(...processedData);
      }
      setHsndata(allData);
      setIsLoadinghsn(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const handleScrollhsn = () => {
    const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
    if (scrollHeight - (scrollTop + clientHeight) < 100) {
      // You can adjust the threshold
      // Load more data
      // In this case, we don't need to fetch more data as we have already fetched all pages upfront.
      // We can simply show more items from the `data123` array.
    }
  };
  //hsn type data fetch end
  //material type data fetch start
  const [materialdata, setMaterialdata] = React.useState([]);
  const [isLoadingmat, setIsLoadingmat] = React.useState(false);
  useEffect(() => {
    fetchData7();
    window.addEventListener('scroll', handleScrollmat);
    return () => {
      window.removeEventListener('scroll', handleScrollmat);
    };
  }, []);
  const fetchData7 = async () => {
    if (isLoadingmat) {
      return;
    }
    setIsLoadingmat(true);
    try {
      const response = await fetch(`${ip}/api/mstmaterials?&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${ip}/api/mstmaterials?&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.MaterialName,
          value: item.attributes.MaterialCode
        }));
        allData.push(...processedData);
      }
      setMaterialdata(allData);
      setIsLoadingmat(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const handleScrollmat = () => {
    const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
    if (scrollHeight - (scrollTop + clientHeight) < 100) {
      // You can adjust the threshold
      // Load more data
      // In this case, we don't need to fetch more data as we have already fetched all pages upfront.
      // We can simply show more items from the `data123` array.
    }
  };

  const handleUploadExcelcbm = (index, unit, length, width, height) => {
    const updatedRows = [...rows];
    if (unit === 'cm') {
      const cbmValue = (length * width * height) / 1000000;
      updatedRows[index].cbm = cbmValue.toFixed(4);
    } else if (unit === 'inch') {
      const cbmValue = (length * width * height) / 61023;
      updatedRows[index].cbm = cbmValue.toFixed(4);
    }
  };
  const handleset = async (
    index,
    categoryAndProduct,
    ProductId,
    ProductName,
    Description,
    Carton_Unit,
    Carton_Length,
    Carton_Width,
    Carton_Thick,
    Carton_PCS,
    Carton_CBM,
    Carton_GrsWt,
    SizeUnit,
    Length,
    Width,
    Height,
    cbm,
    FinishName,
    ColorName,
    NetWeight,
    GrossWeight,
    HSNCode,
    SellingPriceCurrency,
    SellingPriceUnit,
    SellingPrice,
    ProductCost,
    SearchKeyword,
    MOQ,
    ProductDesigner,
    MadeBy,
    BuyerName,
    BuyerSku
  ) => {
    try {
      // ✅ सिर्फ़ backend sync
      await fetch(`${ip}/api/products`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          data: {
            categoryAndProduct,
            ProductId,
            ProductName,
            Description,
            Carton_Unit,
            Carton_Length,
            Carton_Width,
            Carton_Thick,
            Carton_PCS,
            Carton_CBM,
            Carton_GrsWt,
            SizeUnit,
            Length,
            Width,
            Height,
            cbm,
            FinishName,
            ColorName,
            NetWeight,
            GrossWeight,
            HSNCode,
            SellingPriceCurrency,
            SellingPriceUnit,
            SellingPrice,
            ProductCost,
            SearchKeyword,
            MOQ,
            ProductDesigner,
            MadeBy,
            BuyerName,
            BuyerSku
          }
        })
      });
    } catch (err) {
      console.error('Error in handleset:', err);
    }
  };
  //** new logic */
  const workerRef = React.useRef<Worker | null>(null);
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [processProgress, setProcessProgress] = React.useState({ done: 0, total: 0, message: '' });
  const [rowsState, setRowsState] = React.useState<any[]>([]);
  const CHUNK_SIZE = 35; // tune this value (rows per chunk)
  console.log(processProgress);
  // create and cleanup worker
  React.useEffect(() => {
    // Create worker using URL import (works with Vite / CRA with new URL approach).
    try {
      workerRef.current = new Worker(new URL('./excelWorker.js', import.meta.url));
    } catch (err) {
      console.error('Worker creation error. Ensure bundler supports worker imports.', err);
      workerRef.current = null;
    }

    return () => {
      if (workerRef.current) {
        workerRef.current.terminate();
        workerRef.current = null;
      }
    };
  }, []);

  // ------------------- safeFetchJson helper -------------------
  const safeFetchJson = async (url: string, options: RequestInit = {}) => {
    try {
      const res = await fetch(url, options);
      const json = await res.json().catch(() => null);
      return { ok: res.ok, json, status: res.status };
    } catch (err: any) {
      return { ok: false, error: err?.message || String(err) };
    }
  };

  // ------------------- optimized processExcelChunk (API calls inside) -------------------
  // This version uses the optimized logic provided earlier (creates categories/producttypes/finishes/colors/hsn
  // and maps final rows). It expects 'createdMaps' to be passed and reused across chunks.
  async function processExcelChunk(
    chunk: any[],
    startIndex: number,
    skippedRows: number[],
    context: any
  ) {
    const {
      categorydata,
      productypedata,
      finishdata,
      colordata,
      hsndata,
      ip,
      generatecategorycode,
      generateptypecode,
      generatefinishcode,
      generatecolorcode,
      calculatePackagingCBM,
      createdMaps // must be same object across calls
    } = context;

    const maps = createdMaps || {
      categories: new Map(),
      productTypes: new Map(),
      finishes: new Map(),
      colors: new Map(),
      hsns: new Map(),
      counters: {
        categoryCounter: categorymeta?.pagination?.total || 0,
        productTypeCounter: productypemeta?.pagination?.total || 0,
        finishCounter: finishmeta?.pagination?.total || 0,
        colorCounter: colormeta?.pagination?.total || 0
      }
    };
    if (!maps.productIdCounters) {
      maps.productIdCounters = new Map<string, number>();
    }

    const createdCategories = maps.categories;
    const createdProductTypes = maps.productTypes;
    const createdFinishes = maps.finishes;
    const createdColors = maps.colors;
    const createdHSNCodes = maps.hsns;
    const counters = maps.counters;

    // local helpers (similar to earlier provided function)
    const resolveOrCreateCategory = async (categoryName: string) => {
      if (!categoryName) return '';
      const key = categoryName.toLowerCase().trim();
      if (createdCategories.has(key)) return createdCategories.get(key)!;
      const local = categorydata.find(
        c => c.label && c.label.toLowerCase().trim() === key.toLowerCase().trim()
      );
      if (local && local.value) {
        createdCategories.set(key, local.value);
        return local.value;
      }
      const search = await safeFetchJson(
        `${ip}/api/mstcategories?filters[CategoryName][$eqi]=${encodeURIComponent(categoryName)}`
      );
      if (search.ok && Array.isArray(search.json?.data) && search.json.data.length > 0) {
        const code = search.json.data[0].attributes?.CategoryCode;
        if (code) {
          createdCategories.set(key, code);
          return code;
        }
      }
      const nextCode = generatecategorycode(counters.categoryCounter ?? 0);
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({ CategoryName: categoryName, CategoryCode: nextCode, dis: 'Continue' })
      );
      const createRes = await fetch(`${ip}/api/mstcategories`, { method: 'POST', body: formData });
      if (createRes.ok) {
        createdCategories.set(key, nextCode);
        counters.categoryCounter = (counters.categoryCounter || 0) + 1;
        return nextCode;
      }
      return '';
    };

    const resolveOrCreateProductType = async (productTypeName: string, categoryCode: string) => {
      if (!productTypeName || !categoryCode) return '';
      const key = `${productTypeName.toLowerCase().trim()}_${categoryCode}`;
      if (createdProductTypes.has(key)) return createdProductTypes.get(key)!;
      const local = productypedata.find(
        pt =>
          pt.label &&
          pt.label.toLowerCase().trim() === productTypeName.toLowerCase().trim() &&
          String(pt.categoryCode) === String(categoryCode)
      );
      if (local && local.value) {
        createdProductTypes.set(key, local.value);
        return local.value;
      }
      const search = await safeFetchJson(
        `${ip}/api/mstproducttypes?filters[ProductTypeName][$eqi]=${encodeURIComponent(
          productTypeName
        )}&filters[Categorycode][$eq]=${encodeURIComponent(categoryCode)}`
      );
      if (search.ok && Array.isArray(search.json?.data) && search.json.data.length > 0) {
        const code = search.json.data[0].attributes?.ProductTypeCode;
        if (code) {
          createdProductTypes.set(key, code);
          return code;
        }
      }
      const nextCode = generateptypecode(counters.productTypeCounter ?? 0);
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          ProductTypeName: productTypeName,
          ProductTypeCode: nextCode,
          Categorycode: categoryCode,
          dis: 'Continue'
        })
      );
      const createRes = await fetch(`${ip}/api/mstproducttypes`, {
        method: 'POST',
        body: formData
      });
      if (createRes.ok) {
        createdProductTypes.set(key, nextCode);
        counters.productTypeCounter = (counters.productTypeCounter || 0) + 1;
        return nextCode;
      }
      return '';
    };

    const resolveOrCreateFinish = async (finishName: string) => {
      if (!finishName) return '';
      const key = finishName.toLowerCase().trim();
      if (createdFinishes.has(key)) return createdFinishes.get(key)!;
      const local = finishdata.find(f => f.label.toLowerCase().trim() === key);
      if (local && local.value) {
        createdFinishes.set(key, local.value);
        return local.value;
      }
      const search = await safeFetchJson(
        `${ip}/api/mstfinishes?filters[FinishName][$eqi]=${encodeURIComponent(finishName)}`
      );
      if (search.ok && Array.isArray(search.json?.data) && search.json.data.length > 0) {
        const code = search.json.data[0].attributes?.FinishCode;
        if (code) {
          createdFinishes.set(key, code);
          return code;
        }
      }
      const nextCode = generatefinishcode(counters.finishCounter ?? 0);
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({ FinishName: finishName, FinishCode: nextCode, dis: 'Continue' })
      );
      const createRes = await fetch(`${ip}/api/mstfinishes`, { method: 'POST', body: formData });
      if (createRes.ok) {
        createdFinishes.set(key, nextCode);
        counters.finishCounter = (counters.finishCounter || 0) + 1;
        return nextCode;
      }
      return '';
    };

    const resolveOrCreateColor = async (colorName: string) => {
      if (!colorName) return '';
      const key = colorName.toLowerCase().trim();
      if (createdColors.has(key)) return createdColors.get(key)!;
      const local = colordata.find(c => c.label.toLowerCase().trim() === key);
      if (local && local.value) {
        createdColors.set(key, local.value);
        return local.value;
      }
      const search = await safeFetchJson(
        `${ip}/api/mstcolors?filters[ColorName][$eqi]=${encodeURIComponent(colorName)}`
      );
      if (search.ok && Array.isArray(search.json?.data) && search.json.data.length > 0) {
        const code = search.json.data[0].attributes?.ColorCode;
        if (code) {
          createdColors.set(key, code);
          return code;
        }
      }
      const nextCode = generatecolorcode(counters.colorCounter ?? 0);
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({ ColorName: colorName, ColorCode: nextCode, dis: 'Continue' })
      );
      const createRes = await fetch(`${ip}/api/mstcolors`, { method: 'POST', body: formData });
      if (createRes.ok) {
        createdColors.set(key, nextCode);
        counters.colorCounter = (counters.colorCounter || 0) + 1;
        return nextCode;
      }
      return '';
    };

    const resolveOrCreateHSN = async (hsn: string) => {
      if (!hsn) return '';
      const key = hsn.trim();
      if (createdHSNCodes.has(key)) return createdHSNCodes.get(key)!;
      const local = hsndata.find(h => h.label.trim() === key);
      if (local && local.value) {
        createdHSNCodes.set(key, local.value);
        return local.value;
      }
      const search = await safeFetchJson(
        `${ip}/api/msthscodes?filters[hscode][$eq]=${encodeURIComponent(hsn)}`
      );
      if (search.ok && Array.isArray(search.json?.data) && search.json.data.length > 0) {
        const code = search.json.data[0].attributes?.hscode;
        if (code) {
          createdHSNCodes.set(key, code);
          return code;
        }
      }
      const formData = new FormData();
      formData.append('data', JSON.stringify({ hscode: hsn, dis: 'Continue' }));
      const createRes = await fetch(`${ip}/api/msthscodes`, { method: 'POST', body: formData });
      if (createRes.ok) {
        createdHSNCodes.set(key, hsn);
        return hsn;
      }
      return hsn;
    };

    // --- iterate chunk rows and build final rows, creating masters as needed ---
    const builtRows: any[] = [];

    for (let i = 0; i < chunk.length; i++) {
      const infoRow = chunk[i]; // chunk elements are originalRow arrays

      // --- skip empty row check ---
      const isNonEmpty = infoRow.slice(1).some(c => c !== '' && c !== undefined && c !== null);
      if (!isNonEmpty) {
        skippedRows.push({
          row: startIndex + i + 2,
          reason: 'Row is empty'
        });
        continue;
      }

      // --- extract fields ---
      const categoryName = (infoRow[2] || '').toString().trim();
      const productTypeName = (infoRow[3] || '').toString().trim();
      const finishName = (infoRow[12] || '').toString().trim();
      const colorName = (infoRow[13] || '').toString().trim();
      const hsnCode = (infoRow[16] || '').toString().trim();
      const excelProductTypeCode = (infoRow[4] || '').toString().trim(); // ProductTypeCode from Excel
      const excelProductId = (infoRow[4] || '').toString().trim(); // ProductId column

      // --- resolve category ---
      const categoryCode = await resolveOrCreateCategory(categoryName);
      const selectedCategory = categorydata.find(
        c => c.label && normalize(c.label) === normalize(categoryName)
      );

      // --- Validate ProductTypeCode strictly against category sname ---
      let productTypeCode = '';
      let isValidRow = true;

      if (!selectedCategory?.sname) {
        isValidRow = false;
        skippedRows.push({
          row: startIndex + i + 2,
          reason: `Category "${categoryName}" has no shortname (sname)`
        });
      } else {
        const expectedPrefix = selectedCategory.sname + '-';
        if (excelProductTypeCode.startsWith(expectedPrefix)) {
          productTypeCode = excelProductTypeCode; // accept Excel value
        } else {
          isValidRow = false;
          skippedRows.push({
            row: startIndex + i + 2,
            reason: `ProductTypeCode "${excelProductTypeCode}" does not match expected prefix "${expectedPrefix}"`
          });
        }
      }

      if (!isValidRow) continue; // skip row completely if invalid

      // --- resolve other masters ---
      const finishCode = await resolveOrCreateFinish(finishName);
      const colorCode = await resolveOrCreateColor(colorName);
      const finalHsn = await resolveOrCreateHSN(hsnCode);

      // --- ProductId logic (old logic preserved) ---
      let finalProductId = excelProductId;
      if (aliasauto === 'Manual') {
        finalProductId = excelProductId;
      } else if (aliasauto === 'Cate.Shortname + Manual') {
        if (selectedCategory?.sname) {
          const prefix = `${selectedCategory.sname}-`;
          const numericPart = excelProductId?.split('-').pop() || '';
          finalProductId = `${prefix}${numericPart}`;
        }
      } else if (aliasauto === 'Cate.Shortname + Auto') {
        if (selectedCategory?.value && selectedCategory?.sname) {
          const counterKey = selectedCategory.value;
          if (!maps.productIdCounters.has(counterKey)) {
            const response = await fetch(
              `${ip}/api/products?filters[CategoryCode][$eq]=${counterKey}`
            );
            const json = await response.json();
            const existingCount = Number(json.meta?.pagination?.total || 0);
            maps.productIdCounters.set(counterKey, existingCount);
          }
          const nextNumber = maps.productIdCounters.get(counterKey)! + 1;
          maps.productIdCounters.set(counterKey, nextNumber);
          finalProductId = `${selectedCategory.sname}-${nextNumber}`;
        }
      }

      // --- Packaging calculations (old logic) ---
      const cartonUnit = infoRow[27] || '';
      const cartonLength = parseFloat(infoRow[28]) || 0;
      const cartonWidth = parseFloat(infoRow[29]) || 0;
      const cartonThick = parseFloat(infoRow[30]) || 0;
      const cartonPCS = parseInt(infoRow[31]) || 0;
      const cartonCBM = calculatePackagingCBM(cartonUnit, cartonLength, cartonWidth, cartonThick);

      // --- Local lookups for labels ---
      const categoryMatchLocal = categorydata.find(
        c => c.label && c.label.toLowerCase().trim() === (categoryName || '').toLowerCase().trim()
      );

      const productTypeLocal = productypedata.find(
        pt =>
          pt.label &&
          pt.label.toLowerCase().trim() === (productTypeName || '').toLowerCase().trim() &&
          String(pt.categoryCode) === String(categoryCode)
      );

      const finishLocal = finishdata.find(
        f => f.label && f.label.toLowerCase().trim() === (finishName || '').toLowerCase().trim()
      );

      const colorLocal = colordata.find(
        c => c.label && c.label.toLowerCase().trim() === (colorName || '').toLowerCase().trim()
      );

      const hsnLocal = hsndata.find(h => h.label && h.label.trim() === (hsnCode || '').trim());

      // --- Build row with all old fields ---
      const updatedRow = {
        CategoryName: categoryMatchLocal?.label || categoryName || '',
        CategoryCode: categoryMatchLocal?.value || categoryCode || '',
        ProductTypeName: productTypeLocal?.label || productTypeName || '',
        ProductTypeCode: productTypeLocal?.value || productTypeCode || '', // only Excel value
        ProductId: finalProductId || '',
        ProductName: infoRow[5] || '',
        Description: infoRow[6] || '',
        CoverImage: infoRow[1] || '',
        Packaging: [
          {
            Carton_Unit: (cartonUnit || '').toString().toLowerCase().trim() || '',
            Carton_Length: cartonLength || '',
            Carton_Width: cartonWidth || '',
            Carton_Thick: cartonThick || '',
            Carton_PCS: cartonPCS || '',
            Carton_CBM: cartonCBM || '',
            Carton_GrsWt: parseFloat(infoRow[32]) || 0,
            Carton_CBMperpc: cartonPCS > 0 ? parseFloat((cartonCBM / cartonPCS).toFixed(4)) : 0,
            CartonType: 'master',
            ProductCode: infoRow[4] || ''
          }
        ],
        SizeUnit: (infoRow[7] || '').toLowerCase() || '',
        Length: parseFloat(infoRow[8]) || 0,
        Width: parseFloat(infoRow[9]) || 0,
        Height: parseFloat(infoRow[10]) || 0,
        cbm: parseFloat(infoRow[11]) || 0,
        FinishName: finishLocal?.label || finishName,
        FinishCode: finishLocal?.value || finishCode || '',
        ColorName: colorLocal?.label || colorName,
        ColorCode: colorLocal?.value || colorCode || '',
        NetWeight: parseFloat(infoRow[14]) || 0,
        GrossWeight: parseFloat(infoRow[15]) || 0,
        HSNCode: hsnLocal?.value || finalHsn || hsnCode || '',
        SellingPriceCurrency: infoRow[17] || '',
        SellingPriceUnit: parseFloat(infoRow[18]) || 0,
        SellingPrice: parseFloat(infoRow[19]) || 0,
        ProductCost: parseFloat(infoRow[20]) || 0,
        SearchKeyword: infoRow[21]?.toString() || '',
        MOQ: parseInt(infoRow[22]) || 0,
        ProductDesigner: infoRow[23] || '',
        MadeBy: infoRow[24] || '',
        BuyerName: infoRow[25] || '',
        BuyerSku: infoRow[26] || ''
      };

      builtRows.push(updatedRow);

      if (i % 10 === 0) await new Promise(r => setTimeout(r, 0));
    }

    return builtRows;
  }
  const [isRowProcessed, setIsRowProcessed] = useState(false);
  const handlefileupload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    ExcelRenderer(file, async (err: any, response: any) => {
      if (err) {
        toaster.push(
          <Message showIcon type="error">
            Format not supported.
          </Message>
        );
        return;
      }

      const rowsFromExcel = response.rows || [];
      if (rowsFromExcel.length === 0) {
        toaster.push(
          <Message showIcon type="error">
            No data found.
          </Message>
        );
        return;
      }

      const rowsNoHeader = rowsFromExcel.slice(1);
      setTotalRows(rowsNoHeader.length);
      setIsRowProcessed(true);
      setProcessProgress({ done: 0, total: rowsNoHeader.length, message: 'Scanning file…' });

      if (!workerRef.current) {
        setIsRowProcessed(false);
        toaster.push(
          <Message showIcon type="error">
            Worker not available
          </Message>
        );
        return;
      }

      // ---------------- Worker Preprocessing ----------------
      const workerResult = await new Promise<any>((resolve, reject) => {
        const onMessage = (ev: MessageEvent) => {
          const msg = ev.data;
          if (!msg) return;

          if (msg.type === 'progress') {
            setProcessProgress({
              done: msg.done,
              total: rowsNoHeader.length,
              message: msg.message
            });
          }

          if (msg.type === 'error') {
            workerRef.current?.removeEventListener('message', onMessage);
            reject(msg.error);
          }

          if (msg.type === 'done') {
            workerRef.current?.removeEventListener('message', onMessage);
            resolve(msg);
          }
        };

        workerRef.current!.addEventListener('message', onMessage);
        workerRef.current!.postMessage({ rows: rowsNoHeader });
      });

      const { preliminaryRows, skippedRows } = workerResult;

      // ---------------- Chunk Processing (no UI freeze) ----------------
      const createdMaps = {
        categories: new Map(),
        productTypes: new Map(),
        finishes: new Map(),
        colors: new Map(),
        hsns: new Map(),
        counters: {
          categoryCounter: categorymeta?.pagination?.total || 0,
          productTypeCounter: productypemeta?.pagination?.total || 0,
          finishCounter: finishmeta?.pagination?.total || 0,
          colorCounter: colormeta?.pagination?.total || 0
        }
      };

      const finalRows: any[] = [];
      const total = preliminaryRows.length;
      let idx = 0;

      while (idx < total) {
        const slice = preliminaryRows.slice(idx, idx + CHUNK_SIZE).map(p => p.originalRow);

        // Your existing logic inside processExcelChunk remains untouched
        const built = await processExcelChunk(slice, idx, skippedRows, {
          categorydata,
          productypedata,
          finishdata,
          colordata,
          hsndata,
          ip: globalIP || ip,
          generatecategorycode,
          generateptypecode,
          generatefinishcode,
          generatecolorcode,
          calculatePackagingCBM,
          createdMaps
        });

        finalRows.push(...built);
        idx += CHUNK_SIZE;

        setProcessProgress({
          done: idx,
          total,
          message: `Processed ${idx}/${total}`
        });

        await new Promise(r => setTimeout(r, 25)); // <- keeps UI fluid
      }

      // ---------------- STEP 1: Stop Loader ----------------
      setIsRowProcessed(false);
      setShowModal(true);
      setSkippedRowsInfo(skippedRows);

      // ---------------- STEP 2: UI Rendering in batches ----------------
      setRows([]); // reset table first
      let renderIndex = 0;
      const RENDER_CHUNK = 15;

      while (renderIndex < finalRows.length) {
        const batch = finalRows.slice(renderIndex, renderIndex + RENDER_CHUNK);
        setRows(prev => [...prev, ...batch]);

        renderIndex += RENDER_CHUNK;

        setProcessProgress({
          done: renderIndex,
          total: finalRows.length,
          message: `Rendering ${renderIndex}/${finalRows.length} rows…`
        });

        await new Promise(r => setTimeout(r, 30)); // UI gets time to render
      }

      setProcessProgress({
        done: finalRows.length,
        total: finalRows.length,
        message: 'All rows loaded'
      });
    });
  };
  //**end here */

  // const handlefileupload = async (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = event.target.files?.[0];
  //   if (!file) return console.error("No file selected.");

  //   ExcelRenderer(file, async (err, response) => {
  //     if (err) {
  //       console.error("Error reading the Excel file:", err);
  //       toaster.push(
  //         <Message showIcon type="error">Format not supported. Please recheck.</Message>,
  //         { placement: "topCenter" }
  //       );
  //       return;
  //     }

  //     const rowsFromExcel = response.rows;
  //     setTotalRows(rowsFromExcel.length);
  //     setIsLoading(true);

  //     if (!rowsFromExcel || rowsFromExcel.length === 0) {
  //       console.error("No data found in the Excel file.");
  //       toaster.push(
  //         <Message showIcon type="error">No data found in the Excel file.</Message>,
  //         { placement: "topCenter" }
  //       );
  //       setIsLoading(false);
  //       return;
  //     }

  //     const skippedRows: number[] = [];
  //     const uniqueCategories = new Set();
  //     const uniqueProductTypes = new Set();
  //     const uniqueFinishes = new Set();
  //     const uniqueColors = new Set();
  //     const uniqueHSNCodes = new Set();

  //     const createdCategories = new Map();
  //     const createdProductTypes = new Map();
  //     const createdFinishes = new Map();
  //     const createdColors = new Map();
  //     const createdHSNCodes = new Map();

  //     // First pass: collect unique items
  //     const preliminaryRows = rowsFromExcel.slice(1).map((excelRow, idx) => {
  //       const isNonEmptyRow = excelRow.slice(1).some(cell => cell !== undefined && cell !== null && cell !== "");
  //       if (!isNonEmptyRow) {
  //         skippedRows.push(idx + 2);
  //         return null;
  //       }

  //       const categoryName = excelRow[2]?.toString().trim() || "";
  //       const productTypeName = excelRow[3]?.toString().trim() || "";
  //       const finishName = excelRow[12]?.toString().trim() || "";
  //       const colorName = excelRow[13]?.toString().trim() || "";
  //       const hsnCode = excelRow[16]?.toString() || "";

  //       // Check if items don't exist in current data (case-insensitive)
  //       if (categoryName && !categorydata.find(item => item.label.toLowerCase().trim() === categoryName.toLowerCase())) {
  //         uniqueCategories.add(categoryName);
  //       }
  //       if (productTypeName && !productypedata.find(item => item.label.toLowerCase().trim() === productTypeName.toLowerCase())) {
  //         uniqueProductTypes.add(productTypeName);
  //       }
  //       if (finishName && !finishdata.find(item => item.label.toLowerCase().trim() === finishName.toLowerCase())) {
  //         uniqueFinishes.add(finishName);
  //       }
  //       if (colorName && !colordata.find(item => item.label.toLowerCase().trim() === colorName.toLowerCase())) {
  //         uniqueColors.add(colorName);
  //       }
  //       if (hsnCode && !hsndata.find(item => item.label.trim() === hsnCode.trim())) {
  //         uniqueHSNCodes.add(hsnCode.trim());
  //       }

  //       return {
  //         categoryName,
  //         productTypeName,
  //         finishName,
  //         colorName,
  //         hsnCode: hsnCode.trim(),
  //         originalRow: excelRow,
  //         index: idx
  //       };
  //     }).filter(row => row !== null);

  //     // Create categories
  //     let categoryCounter = categorymeta?.pagination?.total || 0;
  //     for (const categoryName of uniqueCategories) {
  //       try {
  //         const existingCategory = categorydata.find(
  //           item => item.label.toLowerCase().trim() === categoryName.toLowerCase().trim()
  //         );

  //         if (existingCategory) {
  //           createdCategories.set(categoryName, existingCategory.value);
  //           console.log(`Category "${categoryName}" already exists locally with code: ${existingCategory.value}`);
  //           continue;
  //         }

  //         const nextCategoryCode = generatecategorycode(categoryCounter);
  //         const searchResponse = await fetch(
  //           `${ip}/api/mstcategories?filters[CategoryName][$eqi]=${encodeURIComponent(categoryName)}`
  //         );
  //         const searchData = await searchResponse.json();

  //         if (searchData.data && searchData.data.length > 0) {
  //           const existingCategoryCode = searchData.data[0].attributes.CategoryCode;
  //           createdCategories.set(categoryName, existingCategoryCode);
  //           console.log(`Category "${categoryName}" found in API with code: ${existingCategoryCode}`);
  //         } else {
  //           const formData = new FormData();
  //           formData.append(
  //             "data",
  //             JSON.stringify({
  //               CategoryName: categoryName,
  //               CategoryCode: nextCategoryCode,
  //               dis: "Continue",
  //             })
  //           );

  //           const createResponse = await fetch(`${ip}/api/mstcategories`, {
  //             method: "POST",
  //             body: formData
  //           });

  //           if (createResponse.ok) {
  //             createdCategories.set(categoryName, nextCategoryCode);
  //             categoryCounter++;
  //             console.log(`Created new category "${categoryName}" with code: ${nextCategoryCode}`);
  //           }
  //         }
  //       } catch (error) {
  //         console.error(`Error processing category ${categoryName}:`, error);
  //       }
  //     }

  //     // Create product types
  //     let productTypeCounter = productypemeta?.pagination?.total || 0;
  //     for (const row of preliminaryRows) {
  //       const productTypeName = row.productTypeName;
  //       const categoryCode =
  //         createdCategories.get(row.categoryName) ||
  //         categorydata.find(
  //           (item) => item.label.toLowerCase().trim() === row.categoryName?.toLowerCase().trim()
  //         )?.value;

  //       if (categoryCode && productTypeName) {
  //         try {
  //           const existingProductType = productypedata.find(
  //             item => item.label.toLowerCase().trim() === productTypeName.toLowerCase().trim() &&
  //               item.categoryCode === categoryCode
  //           );

  //           if (existingProductType) {
  //             createdProductTypes.set(
  //               `${productTypeName}_${categoryCode}`,
  //               existingProductType.value
  //             );
  //             continue;
  //           }

  //           const nextProductTypeCode = generateptypecode(productTypeCounter);
  //           const searchResponse = await fetch(
  //             `${ip}/api/mstproducttypes?filters[ProductTypeName][$eqi]=${encodeURIComponent(
  //               productTypeName
  //             )}&filters[Categorycode][$eq]=${categoryCode}`
  //           );

  //           const searchData = await searchResponse.json();

  //           if (searchData.data && searchData.data.length > 0) {
  //             const existingProductTypeCode = searchData.data[0].attributes.ProductTypeCode;
  //             createdProductTypes.set(
  //               `${productTypeName}_${categoryCode}`,
  //               existingProductTypeCode
  //             );
  //           } else {
  //             const formData = new FormData();
  //             formData.append(
  //               "data",
  //               JSON.stringify({
  //                 ProductTypeName: productTypeName,
  //                 ProductTypeCode: nextProductTypeCode,
  //                 Categorycode: categoryCode,
  //                 dis: "Continue",
  //               })
  //             );

  //             const createResponse = await fetch(`${ip}/api/mstproducttypes`, {
  //               method: "POST",
  //               body: formData,
  //             });

  //             if (createResponse.ok) {
  //               createdProductTypes.set(
  //                 `${productTypeName}_${categoryCode}`,
  //                 nextProductTypeCode
  //               );
  //               productTypeCounter++;
  //             }
  //           }
  //         } catch (error) {
  //           console.error(`Error processing product type ${productTypeName}:`, error);
  //         }
  //       }
  //     }

  //     // Create finishes
  //     let finishCounter = finishmeta?.pagination?.total || 0;
  //     for (const finishName of uniqueFinishes) {
  //       try {
  //         // First check in existing local data (case-insensitive)
  //         const existingFinish = finishdata.find(
  //           item => item.label.toLowerCase().trim() === finishName.toLowerCase().trim()
  //         );

  //         if (existingFinish) {
  //           // Finish already exists locally, use existing code
  //           createdFinishes.set(finishName, existingFinish.value);
  //           console.log(`Finish "${finishName}" already exists locally with code: ${existingFinish.value}`);
  //           continue;
  //         }

  //         const nextFinishCode = generatefinishcode(finishCounter);

  //         // Double-check with API (case-insensitive search)
  //         const searchResponse = await fetch(
  //           `${ip}/api/mstfinishes?filters[FinishName][$eqi]=${encodeURIComponent(finishName)}`
  //         );
  //         const searchData = await searchResponse.json();

  //         if (searchData.data && searchData.data.length > 0) {
  //           // Finish exists in API but not in local data, use existing code
  //           const existingFinishCode = searchData.data[0].attributes.FinishCode;
  //           createdFinishes.set(finishName, existingFinishCode);
  //           console.log(`Finish "${finishName}" found in API with code: ${existingFinishCode}`);
  //         } else {
  //           // Finish doesn't exist, create new one
  //           const formData = new FormData();
  //           formData.append("data", JSON.stringify({
  //             FinishName: finishName, // Keep original case from Excel
  //             FinishCode: nextFinishCode,
  //             dis: "Continue"
  //           }));

  //           const createResponse = await fetch(`${ip}/api/mstfinishes`, {
  //             method: "POST",
  //             body: formData
  //           });

  //           if (createResponse.ok) {
  //             createdFinishes.set(finishName, nextFinishCode);
  //             finishCounter++;
  //             console.log(`Created new finish "${finishName}" with code: ${nextFinishCode}`);
  //           } else {
  //             console.error(`Failed to create finish "${finishName}"`);
  //           }
  //         }
  //       } catch (error) {
  //         console.error(`Error processing finish ${finishName}:`, error);
  //       }
  //     }

  //     // Create colors
  //     let colorCounter = colormeta?.pagination?.total || 0;
  //     for (const colorName of uniqueColors) {
  //       try {
  //         // First check in existing local data (case-insensitive)
  //         const existingColor = colordata.find(
  //           item => item.label.toLowerCase().trim() === colorName.toLowerCase().trim()
  //         );

  //         if (existingColor) {
  //           // Color already exists locally, use existing code
  //           createdColors.set(colorName, existingColor.value);
  //           console.log(`Color "${colorName}" already exists locally with code: ${existingColor.value}`);
  //           continue;
  //         }

  //         const nextColorCode = generatecolorcode(colorCounter);

  //         // Double-check with API (case-insensitive search)
  //         const searchResponse = await fetch(
  //           `${ip}/api/mstcolors?filters[ColorName][$eqi]=${encodeURIComponent(colorName)}`
  //         );
  //         const searchData = await searchResponse.json();

  //         if (searchData.data && searchData.data.length > 0) {
  //           // Color exists in API but not in local data, use existing code
  //           const existingColorCode = searchData.data[0].attributes.ColorCode;
  //           createdColors.set(colorName, existingColorCode);
  //           console.log(`Color "${colorName}" found in API with code: ${existingColorCode}`);
  //         } else {
  //           // Color doesn't exist, create new one
  //           const formData = new FormData();
  //           formData.append("data", JSON.stringify({
  //             ColorName: colorName, // Keep original case from Excel
  //             ColorCode: nextColorCode,
  //             dis: "Continue"
  //           }));

  //           const createResponse = await fetch(`${ip}/api/mstcolors`, {
  //             method: "POST",
  //             body: formData
  //           });

  //           if (createResponse.ok) {
  //             createdColors.set(colorName, nextColorCode);
  //             colorCounter++;
  //             console.log(`Created new color "${colorName}" with code: ${nextColorCode}`);
  //           } else {
  //             console.error(`Failed to create color "${colorName}"`);
  //           }
  //         }
  //       } catch (error) {
  //         console.error(`Error processing color ${colorName}:`, error);
  //       }
  //     }

  //     // Create HSN codes
  //     for (const hsnCode of uniqueHSNCodes) {
  //       try {
  //         const searchResponse = await fetch(`${ip}/api/msthscodes?filters[hscode][$eq]=${encodeURIComponent(hsnCode)}`);
  //         const searchData = await searchResponse.json();

  //         if (searchData.data.length === 0) {
  //           const formData = new FormData();
  //           formData.append("data", JSON.stringify({
  //             hscode: hsnCode,
  //             dis: "Continue"
  //           }));

  //           await fetch(`${ip}/api/msthscodes`, { method: "POST", body: formData });
  //           createdHSNCodes.set(hsnCode, hsnCode);
  //         } else {
  //           createdHSNCodes.set(hsnCode, searchData.data[0].attributes.hscode);
  //         }
  //       } catch (error) {
  //         console.error(`Error creating HSN code ${hsnCode}:`, error);
  //       }
  //     }

  //     // ✅ CRITICAL: Refresh all local data arrays
  //     console.log("Refreshing local data...");
  //     await Promise.all([
  //       fetchData(),    // Categories
  //       fetchData2(),   // Product Types
  //       fetchData4(),   // Finishes
  //       fetchData5(),   // Colors
  //       fetchData6()    // HSN Codes
  //     ]);
  //     console.log("Local data refreshed successfully!");

  //     // Wait a bit to ensure data is loaded
  //     await new Promise(resolve => setTimeout(resolve, 1000));

  //     // Create final rows with updated local data
  //     const newRows = preliminaryRows.map(rowInfo => {
  //       const excelRow = rowInfo.originalRow;

  //       const cartonUnit = excelRow[27] || "";
  //       const cartonLength = parseFloat(excelRow[28]) || 0;
  //       const cartonWidth = parseFloat(excelRow[29]) || 0;
  //       const cartonThick = parseFloat(excelRow[30]) || 0;
  //       const cartonPCS = parseInt(excelRow[31]) || 0;
  //       const cartonCBM = calculatePackagingCBM(cartonUnit, cartonLength, cartonWidth, cartonThick);

  //       // Use the updated local data for mapping
  //       const categoryMatch = categorydata.find(item =>
  //         item.label.toLowerCase().trim() === rowInfo.categoryName.toLowerCase().trim()
  //       );
  //       const productTypeMatch = productypedata.find(item =>
  //         item.label.toLowerCase().trim() === rowInfo.productTypeName.toLowerCase().trim()
  //       );
  //       const finishMatch = finishdata.find(item =>
  //         item.label.toLowerCase().trim() === rowInfo.finishName.toLowerCase().trim()
  //       );
  //       const colorMatch = colordata.find(item =>
  //         item.label.toLowerCase().trim() === rowInfo.colorName.toLowerCase().trim()
  //       );
  //       const hsnMatch = hsndata.find(item =>
  //         item.label.trim() === rowInfo.hsnCode
  //       );

  //       let updatedRow = {
  //         CategoryName: categoryMatch?.label || rowInfo.categoryName,
  //         CategoryCode: categoryMatch?.value || createdCategories.get(rowInfo.categoryName) || "",
  //         ProductTypeName: productTypeMatch?.label || rowInfo.productTypeName,
  //         ProductTypeCode: productTypeMatch?.value ||
  //           createdProductTypes.get(`${rowInfo.productTypeName}_${categoryMatch?.value}`) || "",
  //         ProductId: String(excelRow[4]) || "",
  //         ProductName: excelRow[5] || "",
  //         Description: excelRow[6] || "",
  //         CoverImage: excelRow[1] || "",
  //         Packaging: [{
  //           Carton_Unit: cartonUnit?.toString().toLowerCase().trim() || "",
  //           Carton_Length: cartonLength,
  //           Carton_Width: cartonWidth,
  //           Carton_Thick: cartonThick,
  //           Carton_PCS: cartonPCS,
  //           Carton_CBM: cartonCBM,
  //           Carton_GrsWt: parseFloat(excelRow[32]) || 0,
  //           Carton_CBMperpc: cartonPCS > 0 ? parseFloat((cartonCBM / cartonPCS).toFixed(4)) : 0,
  //           CartonType: "master",
  //           ProductCode: excelRow[4] || ""
  //         }],
  //         SizeUnit: excelRow[7]?.toLowerCase() || "",
  //         Length: parseFloat(excelRow[8]) || 0,
  //         Width: parseFloat(excelRow[9]) || 0,
  //         Height: parseFloat(excelRow[10]) || 0,
  //         cbm: parseFloat(excelRow[11]) || 0,
  //         FinishName: finishMatch?.label || rowInfo.finishName,
  //         FinishCode: finishMatch?.value || createdFinishes.get(rowInfo.finishName) || "",
  //         ColorName: colorMatch?.label || rowInfo.colorName,
  //         ColorCode: colorMatch?.value || createdColors.get(rowInfo.colorName) || "",
  //         NetWeight: parseFloat(excelRow[14]) || 0,
  //         GrossWeight: parseFloat(excelRow[15]) || 0,
  //         HSNCode: hsnMatch?.value || createdHSNCodes.get(rowInfo.hsnCode) || rowInfo.hsnCode,
  //         SellingPriceCurrency: excelRow[17] || "",
  //         SellingPriceUnit: parseFloat(excelRow[18]) || 0,
  //         SellingPrice: parseFloat(excelRow[19]) || 0,
  //         ProductCost: parseFloat(excelRow[20]) || 0,
  //         SearchKeyword: excelRow[21]?.toString() || "",
  //         MOQ: parseInt(excelRow[22]) || 0,
  //         ProductDesigner: excelRow[23] || "",
  //         MadeBy: excelRow[24] || "",
  //         BuyerName: excelRow[25] || "",
  //         BuyerSku: excelRow[26] || "",
  //       };

  //       return updatedRow;
  //     });

  //     const filteredRows = newRows.filter(row => row !== null);
  //     setRows(filteredRows as any);
  //     setSkippedRowsInfo(skippedRows);
  //     setIsLoading(false);
  //     setShowModal(true);

  //     console.log("Upload completed successfully!");
  //   });
  // };

  const [uploadedImages, setUploadedImages] = useState([]);

  // Function to add a new row for each uploaded image
  const addRowForImages = () => {
    setImage(false);
    setImage1(true);
    const newRows1 = uploadedImages.map((image, index) => ({
      id: rows.length + index + 1,
      CategoryCode: '',
      ProductTypeCode: '',
      ProductCode: '',
      ProductId: '',
      ProductName: '',
      Description: '',
      SizeUnit: '',
      Length: 0,
      Width: 0,
      Height: 0,
      FinishCode: '',
      ColorCode: '',
      NetWeight: 0,
      GrossWeight: 0,
      HSNCode: '',
      SellingPriceCurrency: '',
      SellingPriceUnit: '',
      SellingPrice: 0,
      ProductCost: 0,
      SearchKeyword: '',
      MOQ: 0,
      ProductDesigner: '',
      MadeBy: '',
      CategoryName: '',
      ProductTypeName: '',
      cbm: 0,
      FinishName: '',
      ColorName: '',
      BuyerName: '',
      BuyerSku: '',
      Product_Remark: '',
      Buyer_Remark: '',
      Shape: '',
      Season: '',
      P_Technique: '',
      SizeRange: '',
      Variant: false,
      SetStatus: 'Single',
      Part: 1,
      MaterialCollection: [
        {
          ProductCode: '',
          MatCollectionNm: '',
          MatCollectionCode: ''
        }
      ],
      ProductionDetail: [
        {
          ProductCode: '',
          MaterialNm: '',
          MaterialFinishNm: '',
          MatNetWeight: 0,
          MaterialCode: '',
          MaterialFinishCode: ''
        }
      ],

      MultipleImage: null,
      CoverImage: image.savefile,
      Total_CBM: 0,
      Total_CFT: 0,
      TwentyFT: '0',
      FortyFT: '0',
      FortyHQ: '0',
      Packaging: [
        {
          CartonType: '',
          ProductCode: '',
          Carton_Unit: '',
          Carton_Length: 0,
          Carton_Width: 0,
          Carton_Thick: 0,
          Carton_CBM: 0,
          Carton_PCS: 0,
          Carton_CBMperpc: 0,
          Carton_GrsWt: 0
        }
      ]
    }));

    setRows(newRows1);
    setStep(3);
    hide();
  };
  const [dataimg, setDataimg] = useState([]);
  const [apiDataLength, setApiDataLength] = useState(0);

  const handleImageUploadq = (fileList: FileList) => {
    deleteFairProducts();
    // Convert fileList to an array
    const filesArray = Array.from(fileList);

    // Function to check if a file is a valid JPG image
    const isValidJPG = file => {
      const validMimeType = file.type === 'image/jpeg';
      const validExtension =
        file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg');
      return validMimeType && validExtension;
    };

    const jpgImages = filesArray.filter(file => isValidJPG(file));
    const otherImages = filesArray.filter(file => !isValidJPG(file));

    // Alert if non-JPG images are uploaded
    if (otherImages.length > 0) {
      alert('Only JPG images are allowed. Other image types will not be uploaded.');
      // You can handle this differently, like showing a message on the UI instead of an alert
    }

    setDataimg(prevImages => [...prevImages, ...jpgImages]);

    const newImages = jpgImages.map(file => ({
      url: URL.createObjectURL(file),
      savefile: file,
      file
    }));

    setUploadedImages(prevImages => [...prevImages, ...newImages]);
    setStep(2);
  };

  useEffect(() => {
    fetchData8();
  }, []);
  const [data, setdata] = useState([]);
  const [data1, setdata1] = useState(0);
  const [mainid, setMainid] = useState(0);
  const fetchData8 = async () => {
    const response = await fetch(`${ip}/api/temp-images?populate=*`);
    console.log(response);
    const json = await response.json();
    // Concatenate data from all pages into a single array

    setdata(json.data);
    setdata1(json.meta.pagination.total);
    const main = json.data.map(item => item.attributes.MainImgId);
    setMainid(main);
    console.log(json.data);
  };

  const exportToExcel1 = async () => {
    // Create a new workbook
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    const headerCellStyle = {
      font: { bold: true }, // Make the header text bold
      alignment: { horizontal: 'center' }, // Center-align header text
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9D9D9' } } // Set header background color
    };
    const oddRowCellStyle = {
      alignment: { horizontal: 'left' },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFECECEC' } } // Set odd row background color
    };

    const evenRowCellStyle = {
      alignment: { horizontal: 'left' },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } } // Set even row background color
    };
    const dataCellStyle = {
      alignment: { horizontal: 'left' } // Left-align data cells
    };
    // Add your table data to the worksheet
    worksheet.addRow([
      'Sr. No.',
      'Image',
      'Category Code',
      'Product Type ',
      'Alias Code',
      'Product Name',
      'Description',
      'SizeUnit',
      'Length',
      'Width',
      'Height',
      'CBM',
      'Finish',
      'Color',
      'Net. Wt.',
      'Gross. Wt.',
      'HSN',
      'Sell. Pr. Cur.',
      'Sell. Pr. Unit',
      'Sell. Pr.',
      'Product Cost',
      'Search keyWord',
      'MOQ',
      'Product Designer',
      'Made By',
      'Buyer Name',
      'Buyer SKU'

      /* Add other column headers */
    ]);
    worksheet.getRow(1).eachCell(cell => {
      cell.style = headerCellStyle;
    });
    worksheet.getColumn(1).width = 10; // Example: Set the width of the first column to 10
    worksheet.getColumn(2).width = 20; // Example: Set the width of the second column to 20
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 20;
    worksheet.getColumn(6).width = 20;
    worksheet.getColumn(7).width = 20;
    worksheet.getColumn(15).width = 20;
    worksheet.getColumn(16).width = 20;
    worksheet.getColumn(18).width = 20;
    worksheet.getColumn(19).width = 20;
    worksheet.getColumn(21).width = 20;
    worksheet.getColumn(22).width = 20;
    worksheet.getColumn(24).width = 20;
    worksheet.getColumn(26).width = 20;
    worksheet.getColumn(27).width = 20;

    rows.forEach((row, rowIndex) => {
      const rowData = [
        row.id,
        row.CoverImage,
        row.CategoryCode,
        row.ProductTypeCode,
        row.ProductId,
        row.ProductName,
        row.Description,
        row.SizeUnit,
        row.Length,
        row.Width,
        row.Height,
        row.cbm,
        row.FinishCode,
        row.ColorCode,
        row.NetWeight,
        row.GrossWeight,
        row.HSNCode,
        row.SellingPriceCurrency,
        row.SellingPriceUnit,
        row.SellingPrice,
        row.ProductCost,
        row.SearchKeyword,
        row.MOQ,
        row.ProductDesigner,
        row.MadeBy,
        row.BuyerName,
        row.BuyerSku
      ];

      const cellStyle = rowIndex % 2 === 0 ? evenRowCellStyle : oddRowCellStyle;

      // Add data row to the worksheet
      const dataRow = worksheet.addRow(rowData);

      // Apply data cell style to the data row
      dataRow.eachCell(cell => {
        cell.style = cellStyle;
      });
    });

    // Generate the Excel file
    const buffer = await workbook.xlsx.writeBuffer();

    // Create a Blob from the buffer and trigger the download
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'table_with_images.xlsx';
    a.click();

    // Clean up
    URL.revokeObjectURL(url);
    setStep(4);
  };

  useEffect(() => {
    // Fetch the existing data from your API
    fetch(url3)
      .then(response => response.json())
      .then(data => {
        // Extract the total number of images from meta.pagination.total
        const totalImages = data.meta.pagination.total || 0;
        setApiDataLength(totalImages);
      })
      .catch(error => console.error(error));
  }, []);
  let meta = data1;
  const generateImgId = () => {
    // Generate an imgid based on the total length of images in the API
    meta = meta + 1;
    return String(meta); // Increment the total length by 1
  };

  const generateMainid = () => {
    // Generate an imgid based on the total length of images in the API

    return String(data.length); // Increment the total length by 1
  };

  const saveImageAndIdToApi = (image, imgid, MainImgId) => {
    const formData = new FormData();
    formData.append('files.img', image);
    console.log('imagesave');
    console.log(image);
    console.log('imgidsave');
    console.log(imgid);
    // Include the image ID in the request data
    let data = {
      imgid: imgid,
      MainImgId: MainImgId
    };
    formData.append('data', JSON.stringify(data));
    fetch(url3, {
      method: 'POST',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        // Handle the API response as needed
      })
      .catch(error => console.error(error));
  };

  const [imgid1, setImgid1] = useState(null);

  const url3 = `${ip}/api/temp-images`;
  const submit2 = e => {
    e.preventDefault();
    // Generate imgid
    const MainImgId = generateMainid();
    setImgid1(MainImgId);

    dataimg.forEach(image => {
      const imgid = generateImgId();
      saveImageAndIdToApi(image, imgid, MainImgId);
    });
  };

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${ip}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  //  const exportToExcel = async () => {
  //   // Create a new workbook and add a worksheet
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Catalogue Data');

  //   const headerCellStyle = {
  //     font: { bold: true },
  //     alignment: { horizontal: 'center' },
  //     fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9D9D9' } }
  //   };

  //   const oddRowCellStyle = {
  //     alignment: { horizontal: 'left' },
  //     fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFECECEC' } }
  //   };

  //   const evenRowCellStyle = {
  //     alignment: { horizontal: 'left' },
  //     fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } }
  //   };

  //   // Add header row with correct order
  //   worksheet.addRow([
  //     'Sr. No.',                                              // Column 1
  //     'Image',                                                // Column 2
  //     `${label[0]?.attributes.Category}`,                     // Column 3
  //     `${label[0]?.attributes.ProductType}`,                  // Column 4
  //     `${label[0]?.attributes.AliasCode}`,                    // Column 5
  //     `${label[0]?.attributes.ProductName}`,                  // Column 6
  //     `${label[0]?.attributes.Description}`,                  // Column 7
  //     'Packaging SizeUnit',                                   // Column 8
  //     'Packaging Length',                                     // Column 9
  //     'Packaging Width',                                      // Column 10
  //     'Packaging Height',                                     // Column 11
  //     'Packaging PCS',                                        // Column 12
  //     'Packaging CBM1',                                       // Column 13
  //     'Packaging GrossWgt',                                   // Column 14
  //     `${label[0]?.attributes.Sizeunit}`,                     // Column 15
  //     `${label[0]?.attributes.length}`,                       // Column 16
  //     `${label[0]?.attributes.width}`,                        // Column 17
  //     `${label[0]?.attributes.height}`,                       // Column 18
  //     `${label[0]?.attributes.cbm}`,                          // Column 19
  //     `${label[0]?.attributes.finish}`,                       // Column 20
  //     `${label[0]?.attributes.color}`,                        // Column 21
  //     `${label[0]?.attributes.NetWgt}`,                       // Column 22
  //     `${label[0]?.attributes.GrossWgt}`,                     // Column 23
  //     `${label[0]?.attributes.HSN}`,                          // Column 24
  //     `${label[0]?.attributes.Currency}`,                     // Column 25
  //     `${label[0]?.attributes.CurRate}`,                      // Column 26
  //     `${label[0]?.attributes.SalePrice}`,                    // Column 27
  //     `${label[0]?.attributes.SalePriceINR}`,                 // Column 28
  //     `${label[0]?.attributes.searchKeyword}`,                // Column 29
  //     `${label[0]?.attributes.MOQ}`,                          // Column 30
  //     `${label[0]?.attributes.ProductDesigner}`,              // Column 31
  //     `${label[0]?.attributes.MadeBy}`,                       // Column 32
  //     `${label[0]?.attributes.BuyerName}`,                    // Column 33
  //     `${label[0]?.attributes.BuyerSku}`                      // Column 34
  //   ]);

  //   // Apply header styling
  //   worksheet.getRow(1).eachCell(cell => {
  //     cell.style = headerCellStyle;
  //   });

  //   // Set column widths
  //   for (let i = 1; i <= 34; i++) {
  //     worksheet.getColumn(i).width = 20;
  //   }

  //   // Add data rows
  //   rows.forEach((row, rowIndex) => {
  //     console.log(rowIndex);
  //     const rowData = [
  //       row.id,                                               // Column 1
  //       row.CoverImage,                                       // Column 2
  //       row.CategoryName,                                     // Column 3
  //       row.ProductTypeName,                                  // Column 4
  //       row.ProductId,                                        // Column 5
  //       row.ProductName,                                      // Column 6
  //       row.Description,                                      // Column 7
  //       row.PackagingSizeUnit || '',                          // Column 8
  //       row.PackagingLength || 0,                             // Column 9
  //       row.PackagingWidth || 0,                              // Column 10
  //       row.PackagingHeight || 0,                             // Column 11
  //       row.PackagingPCS || 0,                                // Column 12
  //       row.PackagingCBM1 || 0,                               // Column 13
  //       row.PackagingGrossWgt || 0,                           // Column 14
  //       row.SizeUnit,                                         // Column 15
  //       row.Length,                                           // Column 16
  //       row.Width,                                            // Column 17
  //       row.Height,                                           // Column 18
  //       row.cbm,                                              // Column 19
  //       row.FinishName,                                       // Column 20
  //       row.ColorName,                                        // Column 21
  //       row.NetWeight,                                        // Column 22
  //       row.GrossWeight,                                      // Column 23
  //       row.HSNCode,                                          // Column 24
  //       row.SellingPriceCurrency,                             // Column 25
  //       row.SellingPriceUnit,                                 // Column 26
  //       row.SellingPrice,                                     // Column 27
  //       row.ProductCost,                                      // Column 28
  //       row.SearchKeyword,                                    // Column 29
  //       row.MOQ,                                              // Column 30
  //       row.ProductDesigner,                                  // Column 31
  //       row.MadeBy,                                           // Column 32
  //       row.BuyerName,                                        // Column 33
  //       row.BuyerSku                                          // Column 34
  //     ];

  //     const cellStyle = rowIndex % 2 === 0 ? evenRowCellStyle : oddRowCellStyle;
  //     const dataRow = worksheet.addRow(rowData);

  //     dataRow.eachCell(cell => {
  //       cell.style = cellStyle;
  //     });
  //   });

  //   // Write the Excel file
  //   workbook.xlsx
  //     .writeBuffer()
  //     .then(buffer => {
  //       const blob = new Blob([buffer], {
  //         type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  //       });
  //       const url = URL.createObjectURL(blob);
  //       const a = document.createElement('a');
  //       a.href = url;
  //       a.download = 'Product Details List.xlsx';
  //       a.click();
  //       URL.revokeObjectURL(url);
  //     })
  //     .catch(error => {
  //       console.error('Error saving Excel file:', error);
  //     });
  // };

  // const exportToExcel = async () => {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Catalogue Data');

  //   const headerCellStyle = {
  //     font: { bold: true },
  //     alignment: { horizontal: 'center' },
  //     fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9D9D9' } }
  //   };

  //   const oddRowCellStyle = {
  //     alignment: { horizontal: 'left' },
  //     fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFECECEC' } }
  //   };

  //   const evenRowCellStyle = {
  //     alignment: { horizontal: 'left' },
  //     fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } }
  //   };

  //   // Add header row
  //   worksheet.addRow([
  //     'Sr. No.',
  //     'Image',
  //     `${label[0]?.attributes.Category}`,
  //     `${label[0]?.attributes.ProductType}`,
  //     `${label[0]?.attributes.AliasCode}`,
  //     `${label[0]?.attributes.ProductName}`,
  //     `${label[0]?.attributes.Description}`,
  //     'Packaging SizeUnit',
  //     'Packaging Length',
  //     'Packaging Width',
  //     'Packaging Height',
  //     'Packaging PCS',
  //     'Packaging CBM1',
  //     'Packaging GrossWgt',
  //     `${label[0]?.attributes.Sizeunit}`,
  //     `${label[0]?.attributes.length}`,
  //     `${label[0]?.attributes.width}`,
  //     `${label[0]?.attributes.height}`,
  //     `${label[0]?.attributes.cbm}`,
  //     `${label[0]?.attributes.finish}`,
  //     `${label[0]?.attributes.color}`,
  //     `${label[0]?.attributes.NetWgt}`,
  //     `${label[0]?.attributes.GrossWgt}`,
  //     `${label[0]?.attributes.HSN}`,
  //     `${label[0]?.attributes.Currency}`,
  //     `${label[0]?.attributes.CurRate}`,
  //     `${label[0]?.attributes.SalePrice}`,
  //     `${label[0]?.attributes.SalePriceINR}`,
  //     `${label[0]?.attributes.searchKeyword}`,
  //     `${label[0]?.attributes.MOQ}`,
  //     `${label[0]?.attributes.ProductDesigner}`,
  //     `${label[0]?.attributes.MadeBy}`,
  //     `${label[0]?.attributes.BuyerName}`,
  //     `${label[0]?.attributes.BuyerSku}`
  //   ]);

  //   worksheet.getRow(1).eachCell(cell => {
  //     cell.style = headerCellStyle;
  //   });

  //   for (let i = 1; i <= 34; i++) {
  //     worksheet.getColumn(i).width = 20;
  //   }

  //   // Export data with image handling
  //   rows.forEach((row, rowIndex) => {
  //     // Handle image - export only the name or URL, not the file object
  //     let imageReference = '';
  //     if (row.CoverImage) {
  //       if (typeof row.CoverImage === 'string') {
  //         imageReference = row.CoverImage; // Already a URL/path
  //       } else if (row.CoverImage.name) {
  //         imageReference = row.CoverImage.name; // File name
  //       } else if (row.CoverImage.url) {
  //         imageReference = row.CoverImage.url; // Image URL
  //       }
  //     }

  //     const rowData = [
  //       row.id,
  //       imageReference, // Export image reference, not the file object
  //       row.CategoryName,
  //       row.ProductTypeName,
  //       row.ProductId,
  //       row.ProductName,
  //       row.Description,
  //       row.PackagingSizeUnit || '',
  //       row.PackagingLength || 0,
  //       row.PackagingWidth || 0,
  //       row.PackagingHeight || 0,
  //       row.PackagingPCS || 0,
  //       row.PackagingCBM1 || 0,
  //       row.PackagingGrossWgt || 0,
  //       row.SizeUnit,
  //       row.Length,
  //       row.Width,
  //       row.Height,
  //       row.cbm,
  //       row.FinishName,
  //       row.ColorName,
  //       row.NetWeight,
  //       row.GrossWeight,
  //       row.HSNCode,
  //       row.SellingPriceCurrency,
  //       row.SellingPriceUnit,
  //       row.SellingPrice,
  //       row.ProductCost,
  //       row.SearchKeyword,
  //       row.MOQ,
  //       row.ProductDesigner,
  //       row.MadeBy,
  //       row.BuyerName,
  //       row.BuyerSku
  //     ];

  //     const cellStyle = rowIndex % 2 === 0 ? evenRowCellStyle : oddRowCellStyle;
  //     const dataRow = worksheet.addRow(rowData);

  //     dataRow.eachCell(cell => {
  //       cell.style = cellStyle;
  //     });
  //   });

  //   // Write Excel file
  //   workbook.xlsx
  //     .writeBuffer()
  //     .then(buffer => {
  //       const blob = new Blob([buffer], {
  //         type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  //       });
  //       const url = URL.createObjectURL(blob);
  //       const a = document.createElement('a');
  //       a.href = url;
  //       a.download = 'Product Details List.xlsx';
  //       a.click();
  //       URL.revokeObjectURL(url);
  //     })
  //     .catch(error => {
  //       console.error('Error saving Excel file:', error);
  //     });
  // };
  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Catalogue Data');

    const headerCellStyle = {
      font: { bold: true },
      alignment: { horizontal: 'center' },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9D9D9' } }
    };

    const oddRowCellStyle = {
      alignment: { horizontal: 'left' },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFECECEC' } }
    };

    const evenRowCellStyle = {
      alignment: { horizontal: 'left' },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } }
    };

    // Add header row
    worksheet.addRow([
      'Sr. No.',
      'Image',
      `${label[0]?.attributes.Category}`,
      `${label[0]?.attributes.ProductType}`,
      `${label[0]?.attributes.AliasCode}`,
      `${label[0]?.attributes.ProductName}`,
      `${label[0]?.attributes.Description}`,
      `${label[0]?.attributes.Sizeunit}`,
      `${label[0]?.attributes.length}`,
      `${label[0]?.attributes.width}`,
      `${label[0]?.attributes.height}`,
      `${label[0]?.attributes.cbm}`,
      `${label[0]?.attributes.finish}`,
      `${label[0]?.attributes.color}`,
      `${label[0]?.attributes.NetWgt}`,
      `${label[0]?.attributes.GrossWgt}`,
      `${label[0]?.attributes.HSN}`,
      `${label[0]?.attributes.Currency}`,
      `${label[0]?.attributes.CurRate}`,
      `${label[0]?.attributes.SalePrice}`,
      `${label[0]?.attributes.SalePriceINR}`,
      `${label[0]?.attributes.searchKeyword}`,
      `${label[0]?.attributes.MOQ}`,
      `${label[0]?.attributes.ProductDesigner}`,
      `${label[0]?.attributes.MadeBy}`,
      `${label[0]?.attributes.BuyerName}`,
      `${label[0]?.attributes.BuyerSku}`,

      // ✅ Packaging fields moved last
      'Packaging Size Unit',
      'Packaging Length',
      'Packaging Width',
      'Packaging Height',
      'Packaging PCS',
      'Packaging CBM',
      'Packaging Gross Wt.'
    ]);

    worksheet.getRow(1).eachCell(cell => {
      cell.style = headerCellStyle;
    });

    for (let i = 1; i <= 34; i++) {
      worksheet.getColumn(i).width = 20;
    }

    // Export data with image handling
    rows.forEach((row, rowIndex) => {
      const packaging = row.Packaging?.[0] || {};

      // Handle image - export only the name or URL, not the file object
      let imageReference = '';
      if (row.CoverImage) {
        if (typeof row.CoverImage === 'string') {
          imageReference = row.CoverImage; // Already a URL/path
        } else if (row.CoverImage.name) {
          imageReference = row.CoverImage.name; // File name
        } else if (row.CoverImage.url) {
          imageReference = row.CoverImage.url; // Image URL
        }
      }

      const rowData = [
        row.id,
        imageReference,
        row.CategoryName,
        row.ProductTypeName,
        row.ProductId,
        row.ProductName,
        row.Description,
        row.SizeUnit,
        row.Length,
        row.Width,
        row.Height,
        row.cbm,
        row.FinishName,
        row.ColorName,
        row.NetWeight,
        row.GrossWeight,
        row.HSNCode,
        row.SellingPriceCurrency,
        row.SellingPriceUnit,
        row.SellingPrice,
        row.ProductCost,
        row.SearchKeyword,
        row.MOQ,
        row.ProductDesigner,
        row.MadeBy,
        row.BuyerName,
        row.BuyerSku,

        // ✅ Packaging data last
        packaging.Carton_Unit || '',
        packaging.Carton_Length || 0,
        packaging.Carton_Width || 0,
        packaging.Carton_Thick || 0,
        packaging.Carton_PCS || 0,
        packaging.Carton_CBM || 0,
        packaging.Carton_GrsWt || 0
      ];

      const cellStyle = rowIndex % 2 === 0 ? evenRowCellStyle : oddRowCellStyle;
      const dataRow = worksheet.addRow(rowData);

      dataRow.eachCell(cell => {
        cell.style = cellStyle;
      });
    });

    // Write Excel file
    workbook.xlsx
      .writeBuffer()
      .then(buffer => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Product Details List.xlsx';
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Error saving Excel file:', error);
      });
  };

  const [auth, setAuth] = useState(false);
  const [userDetails, setUserDetails] = useState(false);
  const [aliasauto, setAliasauto] = useState(null);

  useEffect(() => {
    fetchDatacompany();
  }, []);
  const [pendingProductId, setPendingProductId] = useState('');
  useEffect(() => {
    if (!pendingProductId) return;

    const timer = setTimeout(async () => {
      const res = await fetch(`${ip}/api/products?filters[ProductId][$eq]=${pendingProductId}`);
      const json = await res.json();
      if (json?.data?.length > 0) {
        toaster.push(
          <Message type="error" showIcon>
            Style No "{pendingProductId}" already exists. Please choose a different one.
          </Message>
        );
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [pendingProductId]);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details?populate=*`);
      const json = await response.json();
      setAuth(json.data[0].attributes.Authorised);
      setPackagingBulkUpload(json.data[0].attributes.PackagingBulkUpload ?? false);
      setAliasauto(json.data[0].attributes.AliasShort);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const userName = localStorage.getItem('id');
  useEffect(() => {
    fetchUserName(); // Calling the async function
  }, []);
  const fetchUserName = async () => {
    try {
      const response = await fetch(
        `${ip}/api/user-details?populate=*&filters[id][$eq]=${userName}`
      );
      const res = await response.json();
      setUserDetails(res.data[0]?.attributes?.Authorised);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };
  const url2 = `${ip}/api/products`;
  const [errorInput, setErrorInput] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setIsLoadsubmit(true); // Start loading
    setErrorInput(true);

    for (let row of rows) {
      if (!row.hasOwnProperty('CoverImage')) {
        try {
          // Fetch the default image as a Blob
          const response = await fetch(defaultImg);
          const imageBlob = await response.blob();

          // Create a File object from the Blob
          const defaultImage = new File([imageBlob], 'default-image.jpg', { type: 'image/jpeg' });

          row.CoverImage = defaultImage;
        } catch (error) {
          console.error('Error fetching default image:', error);
          setIsLoadsubmit(false); // Stop loading if error occurs
          return;
        }
      }
    }

    rows.forEach(row => {
      // Calculate packaging CBM if not already calculated
      if (
        !row.PackagingCBM1 &&
        row.PackagingSizeUnit &&
        row.PackagingLength &&
        row.PackagingWidth &&
        row.PackagingHeight &&
        row.PackagingPCS
      ) {
        row.PackagingCBM1 = calculatePackagingCBM(
          row.PackagingSizeUnit,
          row.PackagingLength,
          row.PackagingWidth,
          row.PackagingHeight,
          row.PackagingPCS
        );
      }
    });

    rows.forEach(async row => {
      console.log('Row *********', row);
      if (!row.hasOwnProperty('CoverImage')) {
        try {
          // Fetch the default image as a Blob
          const response = await fetch(defaultImg);
          const imageBlob = await response.blob();

          // Create a File object from the Blob
          const defaultImage = new File([imageBlob], 'default-image.jpg', { type: 'image/jpeg' });

          row.CoverImage = defaultImage;
        } catch (error) {
          console.error('Error fetching default image:', error);
          setIsLoadsubmit(false); // Stop loading if error occurs
          return;
        }
      }

      if (row.SellingPriceCurrency) {
        row.SellingPriceCurrency = row.SellingPriceCurrency.toUpperCase();
      }

      const category = categorydata.find(cat => cat.label === row.CategoryName);
      if (category) {
        row.CategoryCode = category.value;
      }
      const productype = productypedata.find(prd => prd.label === row.ProductTypeName);
      if (productype) {
        row.ProductTypeCode = productype.value;
      }
      const finish = finishdata.find(fin => fin.label === row.FinishName);
      if (finish) {
        row.FinishCode = finish.value;
      }
      const color = colordata.find(color => color.label === row.ColorName);
      if (color) {
        row.ColorCode = color.value;
      }
    });
    const categoryIndex = rows.findIndex(row => row.CategoryCode === '');
    if (categoryIndex !== -1) {
      toaster.push(
        <Message showIcon type="error">
          Please add Category for row {categoryIndex + 1}.
        </Message>,
        { placement: 'topCenter' }
      );
      setIsLoadsubmit(false); // Stop loading
    } else if (rows.findIndex(row => row.ProductId === '') !== -1) {
      const productIdIndex = rows.findIndex(row => row.ProductId === '');
      toaster.push(
        <Message showIcon type="error">
          Please Enter Alias Code for row {productIdIndex + 1}.
        </Message>,
        { placement: 'topCenter' }
      );
      setIsLoadsubmit(false); // Stop loading
    } else if (rows.findIndex(row => row.CoverImage === null) !== -1) {
      const coverImageIndex = rows.findIndex(row => row.CoverImage === null);
      toaster.push(
        <Message showIcon type="error">
          Please add at least one Product Image for row {coverImageIndex + 1}.
        </Message>,
        { placement: 'topCenter' }
      );
      setIsLoadsubmit(false); // Stop loading
    } else if (rows.findIndex(row => row.ProductName === '') !== -1) {
      const productNameIndex = rows.findIndex(row => row.ProductName === '');
      toaster.push(
        <Message showIcon type="error">
          Please add Product Name for row {productNameIndex + 1}.
        </Message>,
        { placement: 'topCenter' }
      );
      setIsLoadsubmit(false); // Stop loading
    } else {
      e.preventDefault();
      try {
        const userName = localStorage.getItem('fullName');
        const cleanName = userName.replace(/\"/g, '');
        let authorizedStatus;
        if (!auth) {
          authorizedStatus = 'Authorised';
        } else {
          authorizedStatus = userDetails ? 'Authorised' : 'Pending';
        }
        var nextCategoryCode = generateNextCategoryCode();
        const existingProductIds = new Set(data123.map(item => item.attributes.ProductId));
        for (let i = 0; i < rows.length; i++) {
          try {
            nextCategoryCode += 1;
            const productCode = `PRD-${nextCategoryCode}`;

            const formData = new FormData();

            const copiedRows = rows.map(({ id, ...rest }) => rest);
            const currentRow = copiedRows[i];

            if (existingProductIds.has(currentRow.ProductId)) {
              toaster.push(
                <Message showIcon type="error">
                  Alias Code already exists.
                </Message>,
                { placement: 'topCenter' }
              );
              setIsLoadsubmit(false);
              return;
            }

            let sellingPriceUnit = parseFloat(currentRow.SellingPriceUnit);
            sellingPriceUnit = isNaN(sellingPriceUnit) ? '0' : sellingPriceUnit.toString();

            const cartonCBM = Number(currentRow?.Packaging?.[0]?.Carton_CBMperpc) || 0;
            const twentyFT = cartonCBM ? Math.floor(27 / cartonCBM) : 0;
            const fortyFT = cartonCBM ? Math.floor(57 / cartonCBM) : 0;
            const fortyHQ = cartonCBM ? Math.floor(65 / cartonCBM) : 0;

            const { CoverImage, ...safeRow } = currentRow;

            if (CoverImage instanceof File) {
              formData.append('files.CoverImage', CoverImage);
            }
            formData.append(
              'data',
              JSON.stringify({
                ...safeRow,

                Packaging: [
                  {
                    CartonType: 'master',
                    ProductCode: productCode,
                    Carton_Unit: currentRow.Packaging?.[0]?.Carton_Unit || '',
                    Carton_Length: Number(currentRow.Packaging?.[0]?.Carton_Length) || 0,
                    Carton_Width: Number(currentRow.Packaging?.[0]?.Carton_Width) || 0,
                    Carton_Thick: Number(currentRow.Packaging?.[0]?.Carton_Thick) || 0,
                    Carton_CBM: Number(currentRow.Packaging?.[0]?.Carton_CBM) || 0,
                    Carton_PCS: Number(currentRow.Packaging?.[0]?.Carton_PCS) || 0,
                    Carton_CBMperpc: Number(currentRow.Packaging?.[0]?.Carton_CBMperpc) || 0,
                    Carton_GrsWt: Number(currentRow.Packaging?.[0]?.Carton_GrsWt) || 0
                  }
                ],

                ProductCode: productCode,
                Variant_Id: productCode,

                SellingPriceUnit: sellingPriceUnit, // ✅ string
                Authorized: authorizedStatus,

                Total_CBM: cartonCBM,
                Total_CFT: cartonCBM ? cartonCBM * 35.3147 : 0,

                TwentyFT: String(twentyFT), // ✅ string
                FortyFT: String(fortyFT), // ✅ string
                FortyHQ: String(fortyHQ), // ✅ string

                CreatedBy: cleanName,
                SetStatus: 'Single',
                Part: 1,
                Variant: false
              })
            );

            const response = await fetch(url2, {
              method: 'POST',
              body: formData
            });

            const result = await response.json();

            if (!response.ok || result?.error) {
              console.error('Upload failed:', result?.error);
              throw new Error(result?.error?.message || 'Upload failed');
            }
          } catch (error) {
            console.error(error);
            toaster.push(
              <Message showIcon type="error">
                Something went wrong while uploading products
              </Message>,
              { placement: 'topCenter' }
            );
            setIsLoadsubmit(false);
            return;
          }
        }

        setIsLoadsubmit(false);
        onChange1();

        // Loop completed
      } catch (error) {
        console.error(error);
        setIsLoadsubmit(false); // Stop loading on error
      }
      categoryCodeCounter++;
    }
  };

  const [step, setStep] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const openModal = () => {
    setIsModalVisible(true);
  };

  // Function to close the modal
  const closeModal = e => {
    submit2(e);
    addRowForImages();
    setIsModalVisible(false);
    hide();
  };
  const cencel = () => {
    setIsModalVisible(false);
  };
  // Use useEffect to open the modal when the component/page loads
  // useEffect(() => {
  //   openModal();
  // }, []);

  const [open4, setOpen4] = React.useState(false);
  const handleOpen4 = () => setOpen4(true);
  const handleClose4 = () => {
    setOpen4(false);
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };
  const onChange1 = () => {
    handleOpen4();
  };

  // const handleFileChange = (e) => {
  //   const uploadedImages = Array.from(e.target.files);
  //   setDataimg((prevImages) => [...prevImages, ...uploadedImages]);
  // };

  const [imgdata, setImgdata] = useState([]);
  const [detetedIds, setDetetedIds] = useState([]);
  useEffect(() => {
    fttt();
  }, []);
  const fttt = async () => {
    try {
      const response = await fetch(`${ip}/api/temp-images?populate=*&pagination[page]=1`);
      const json = await response.json();
      console.log(json.data, 'json');

      const allData = [];
      const deletedId = [];

      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/temp-images?populate=*&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        const did = pageJson.data.map(i => i.attributes.img.data.id);

        const id = pageJson.data.map(item => item.id);
        allData.push(...id);
        deletedId.push(...did);
      }
      setImgdata(allData);
      console.log(deletedId);

      setDetetedIds(deletedId);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteFairProducts = async () => {
    try {
      // Iterate over each fair product ID and delete it
      for (const fairProductId of imgdata) {
        const response = await fetch(`${ip}/api/temp-images/${fairProductId}`, {
          method: 'DELETE'
        });

        if (response.ok) {
          // If the deletion is successful, log the result or perform any necessary actions
          console.log(`Fair product with ID ${fairProductId} deleted successfully.`);
        } else {
          console.error(`Failed to delete fair product with ID ${fairProductId}.`);
        }
      }
      for (const fairProductId of detetedIds) {
        const response = await fetch(`${ip}/api/upload/files/${fairProductId}`, {
          method: 'DELETE'
        });

        if (response.ok) {
          // If the deletion is successful, log the result or perform any necessary actions
          console.log(`Fair product folder image with ID ${fairProductId} deleted successfully.`);
        } else {
          console.error(`Failed to delete fair product with ID ${fairProductId}.`);
        }
      }
    } catch (error) {
      console.error('Error deleting fair products:', error);
    }
  };
  const handleFolderSelect = () => {
    console.log('handleFolderSelect triggered'); // Debug log

    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*'; // Only allow image files
    input.multiple = true; // Allow multiple image selection

    input.addEventListener('change', async event => {
      console.log('Files selected:', event.target.files);

      const files = Array.from(event.target.files); // Get all files selected
      if (files.length === 0) {
        toaster.push(
          <Message showIcon type="error">
            No valid images found in the folder.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      // Map files to ProductId from rows
      const imagesMap = new Map();
      files.forEach(file => {
        const fileNameWithoutExtension = file.name.split('.')[0]; // Get the file name without extension
        imagesMap.set(fileNameWithoutExtension, file); // Map file to ProductId
      });

      // Fetch and create the default image as a File object
      const defaultImageBlob = await fetch(img)
        .then(res => res.blob())
        .then(blob => new File([blob], 'defaultImage.jpg', { type: 'image/jpeg' }));

      // Update rows
      const updatedRows = rows.map(row => {
        const matchingImage = imagesMap.get(row.ProductId); // Match ProductId with file name
        return {
          ...row,
          CoverImage: matchingImage || defaultImageBlob // Use matching image or default
        };
      });

      console.log('Updated Rows:', updatedRows);
      setRows(updatedRows);

      toaster.push(
        <Message showIcon type="success">
          Images mapped successfully! Default image assigned to unmatched rows.
        </Message>,
        { placement: 'topCenter' }
      );
    });

    input.click(); // Trigger the file dialog
  };

  // const handleFolderSelect = event => {

  //   const files = Array.from(event.target.files); // Get selected files
  //   const images = files.filter(file => /\.(jpg|jpeg|png)$/i.test(file.name)); // Filter for valid image formats

  //   if (images.length === 0) {
  //     toaster.push(
  //       <Message showIcon type="error">
  //         No valid images found in the folder.
  //       </Message>,
  //       { placement: 'topCenter' }
  //     );
  //     return;
  //   }
  //   // Map images to ProductId from rows
  //   const imagesMap = new Map();
  //   images.forEach(file => {
  //     const fileName = file.name.split('.')[0]; // Assuming file name matches ProductId
  //     imagesMap.set(fileName, file);
  //   });
  //   // Define the default image (ensure this path points to your local default image)
  //   const defaultImage = img;
  //   // const defaultImage = {
  //   //   name: 'defaultimg.jpg', // Default image name
  //   //   path: './defImage/defaultimg.jpg', // Local path to the default image
  //   //   type: 'image/jpeg' // MIME type
  //   // };
  //   const defaultImageBlob = fetch(img)
  //     .then(res => res.blob()) // Convert URL to Blob
  //     .then(blob => new File([blob], 'defaultImage.jpg', { type: 'image/jpeg' }));
  //   // Update rows with matching images or assign default image
  //   // Update rows with matching images or assign default image
  //   Promise.resolve(defaultImageBlob).then(defaultImage => {
  //     const updatedRows = rows.map(row => {
  //       const matchingImage = imagesMap.get(row.ProductId);
  //       if (matchingImage) {
  //         return { ...row, CoverImage: matchingImage }; // Update CoverImage with matching image
  //       }
  //       return { ...row, CoverImage: defaultImage }; // Assign default image if no match is found
  //     });

  //     console.log('updatedRows');
  //     console.log(updatedRows);
  //     setRows(updatedRows);

  //     toaster.push(
  //       <Message showIcon type="success">
  //         Images mapped successfully! Default image assigned to unmatched rows.
  //       </Message>,
  //       { placement: 'topCenter' }
  //     );
  //   });
  // };

  const [tableHeight, setTableHeight] = useState(20); // Default height

  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 190; // Adjust based on your header/footer size
      const footerHeight = 10; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize

    return () => window.removeEventListener('resize', calculateHeight);
  }, []);
  return (
    <>
      <Container className="main">
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack className="nav-btn" direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start" className="bulk-update">
              <h3 className="title">Bulk Upload</h3>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/products`}>Product</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Bulk Upload Products</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            {/* <Button appearance='default' active onClick={deleteFairProducts}>Delete</Button> */}
          </Stack>
          <Stack direction="column" alignItems="flex-end" spacing={53} className="bulk-btn">
            <Stack spacing={10}>
              {!isLoading && processProgress?.message && (
                <div
                  style={{
                    // marginBottom: 15,
                    padding: '5px 15px',
                    background: '#f0fafa',
                    borderRadius: 12,
                    border: '1px solid #d8f4f4',
                    width: '100%',
                    maxWidth: 450,
                    textAlign: 'center',
                    color: '#0bbdcf',
                    fontWeight: 600,
                    fontSize: 14
                  }}
                >
                  {processProgress.message}
                </div>
              )}

              {/* <Button
                onClick={() => {
                  console.log('categorydata');
                  console.log(categorydata);
                  console.log('rows');
                  console.log(rows);
                  console.log('rowproductTypeDataPerRows');
                  console.log(productTypeDataPerRow);

                }}
              >Refresh</Button> */}
              <Button appearance="ghost" color="cyan" active onClick={() => handleOpen('sm')}>
                Customize <span className="bulk-btn-heads">Heads</span>
              </Button>
              <div>
                <Button onClick={handleFolderSelect} appearance="primary" color="cyan">
                  Select Image Folder
                </Button>
                {/* <Button appearance="primary" color="cyan"  onChange={handleFolderSelect}>
                  <label htmlFor="folder-input" style={{ cursor: 'pointer' }}>
                    Select Image Folder
                  </label>
                </Button> */}
                {/* <input
                  type="file"
                  id="folder-input"
                  webkitdirectory="" // Enable folder selection in supported browsers
                  multiple
                  accept=".jpg,.jpeg,.png"
                  // onChange={handleFolderSelect}
                  style={{ display: 'none' }}
                /> */}
              </div>

              <div>
                <label>
                  <Button
                    appearance="default"
                    active
                    onClick={exportToExcel}
                    style={{ marginRight: '10px', marginTop: '-12px' }}
                  >
                    Export to Excel
                  </Button>
                </label>
                <label htmlFor="file-upload" className="custom-file-upload">
                  <i className="fa fa-cloud-upload"></i> Import Data
                </label>
                <input
                  id="file-upload"
                  type="file"
                  accept=".xlsx, .xls"
                  onChange={handlefileupload}
                />
              </div>

              <Button
                appearance="primary"
                color="cyan"
                active
                onClick={submit}
                loading={isLoadsubmit}
              >
                Save
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <Divider className="divide-min" style={{ marginTop: '-14px' }} />
        <>
          {isRowProcessed && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.7)', // semi-transparent overlay
                zIndex: 2
              }}
            >
              <Player autoplay loop src={processdata} style={{ height: '300px', width: '300px' }} />
              <div
                style={{
                  marginTop: '20px',
                  fontSize: '14px',
                  color: '#2edde8',
                  fontWeight: 'bold'
                }}
              >
                {processProgress?.done}/{processProgress?.total} rows processed...
              </div>
            </div>
          )}
          {isLoadsubmit && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.7)', // semi-transparent overlay
                zIndex: 2
              }}
            >
              <Player autoplay loop src={addsubmit} style={{ height: '300px', width: '300px' }} />
              <b style={{ fontStyle: 'italic' }}>Saving Products...</b>
            </div>
          )}
          <Table
            height={tableHeight}
            rowHeight={80}
            data={rows}
            virtualized
            hover={false}
            // loading={isLoading}
            // style={{
            //   marginBottom: "20px",
            //   opacity: isLoading ? 0.4 : 1,
            //   transition: "opacity 0.2s ease"
            // }}
          >
            <Table.Column width={60} fixed>
              <Table.HeaderCell>
                <b>Sr. No.</b>
              </Table.HeaderCell>
              <Table.Cell>{(_, rowIndex) => rowIndex + 1}</Table.Cell>
            </Table.Column>
            {image && (
              <Table.Column width={100} fixed>
                <Table.HeaderCell>
                  <b>Image</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <Uploader
                      listType="picture"
                      accept=".jpeg,.jpg"
                      action={''}
                      // action="http://192.168.1.3:1337/api/products"
                      fileList={
                        rowData.CoverImage
                          ? [
                              {
                                file: rowData.CoverImage,
                                name: rowData.CoverImage.name,
                                blobFile: rowData.CoverImage
                              }
                            ]
                          : [] // Show existing CoverImage if available
                      }
                      onChange={fileList => handleImageUpload(fileList, rowIndex)}
                      style={{ marginTop: '-16px' }}
                    >
                      <button>
                        <CameraRetroIcon />
                      </button>
                    </Uploader>
                  )}
                </Table.Cell>
              </Table.Column>
            )}

            {image1 && (
              <Table.Column width={100} fixed>
                <Table.HeaderCell>
                  <b>Image</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <Uploader
                      listType="picture"
                      accept=".jpeg,.jpg"
                      action={''}
                      // action="http://192.168.1.3:1337/api/products"
                      fileList={[{ url: URL.createObjectURL(rowData.CoverImage) }]} // Assuming rowData.CoverImage contains the image URL
                      onChange={fileList => handleImageUpload(fileList, rowIndex)}
                      style={{ marginTop: '-16px' }}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {category && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <Stack>
                    <b>{label[0]?.attributes.Category}</b>
                    <p style={{ color: 'red' }}>*</p>
                  </Stack>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <SelectPicker
                      id="CategoryName"
                      name="CategoryName"
                      value={rowData.CategoryName || ''}
                      onChange={value => handleChange(rowIndex, 'CategoryName', value)}
                      data={categorydata}
                      placeholder="Select"
                      menuMaxHeight={180}
                      // menuStyle={{ width: 200 }}
                      labelKey="label"
                      valueKey="label"
                      placement="auto"
                      block
                      onOpen={fetchData}
                      style={{
                        borderColor: rowData.CategoryName === '' && errorInput ? 'red' : '#e6e6eb',
                        boxShadow:
                          rowData.CategoryName === '' && errorInput ? '0px 0px 4px red' : '',
                        borderRadius: '6px'
                      }}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {Productype && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.ProductType}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {
                    (rowData, rowIndex) => (
                      // <SelectPicker
                      //   id="ProductTypeName"
                      //   name="ProductTypeName"
                      //   value={rowData.ProductTypeName}
                      //   onChange={value => handleChange(rowIndex, 'ProductTypeName', value)}
                      //   data={productTypeDataPerRow[rowIndex] || []}
                      //   placeholder={rowData.ProductTypeName}
                      //   menuMaxHeight={180}
                      //   // menuStyle={{ width: 200 }}
                      //   labelKey="label"
                      //   valueKey="label"
                      //   placement="auto"
                      //   block
                      // />
                      <SelectPicker
                        id="ProductTypeName"
                        name="ProductTypeName"
                        value={rowData.ProductTypeName}
                        onChange={value => handleChange(rowIndex, 'ProductTypeName', value)}
                        data={
                          productTypeDataPerRow[rowIndex] &&
                          productTypeDataPerRow[rowIndex].length > 0
                            ? productTypeDataPerRow[rowIndex]
                            : productypedata
                        }
                        placeholder="Select Product Type"
                        menuMaxHeight={180}
                        labelKey="label"
                        valueKey="label"
                        placement="auto"
                        block
                      />
                    )
                    // <Input
                    //   value={rowData.ProductType}
                    //   onChange={(value) => handleChange(rowIndex, 'ProductType', value)}
                    // />
                  }
                </Table.Cell>
              </Table.Column>
            )}

            {productID && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <Stack>
                    <b>{label[0]?.attributes.AliasCode}</b>
                    <p style={{ color: 'red' }}>*</p>
                  </Stack>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <Input
                      id={`ProductId-${rowIndex}`}
                      name={`ProductId-${rowIndex}`}
                      value={rowData && rowData.ProductId ? rowData.ProductId : ''}
                      style={{
                        borderColor: rowData.ProductId === '' && errorInput ? '#ff9e9e' : '#e6e6eb',
                        boxShadow:
                          rowData.ProductId === '' && errorInput ? '0px 0px 4px #ff9e9e' : ''
                      }}
                      onBlur={async e => {
                        const value = e.target.value;
                        handleChange(rowIndex, 'ProductId', value);

                        if (value.trim() !== '') {
                          const duplicateRowIndex = rows.findIndex(
                            (row, i) => i !== rowIndex && row.ProductId === value
                          );
                          if (duplicateRowIndex !== -1) {
                            toaster.push(
                              <Message showIcon type="error">
                                Sr. No {duplicateRowIndex + 1} has the same Product ID. Please
                                change.
                              </Message>,
                              { placement: 'topCenter' }
                            );
                            // Clear the current input value and update the state
                            handleChange(rowIndex, 'ProductId', '');
                          }
                        }
                      }}
                      onChange={value => {
                        handleChange(rowIndex, 'ProductId', value.trimStart());
                      }}
                      readOnly={aliasauto == 'Cate.Shortname + Auto'}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {productname && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <Stack>
                    <b>{label[0]?.attributes.ProductName}</b>
                    <p style={{ color: 'red' }}>*</p>
                  </Stack>
                </Table.HeaderCell>
                <Table.Cell dataKey="ProductName">
                  {(rowData, rowIndex) => (
                    <Input
                      id={`ProductName-${rowIndex}`}
                      name={`ProductName-${rowIndex}`}
                      value={rowData.ProductName || ''}
                      style={{
                        borderColor:
                          rowData.ProductName === '' && errorInput ? '#ff9e9e' : '#e6e6eb',
                        boxShadow:
                          rowData.ProductName === '' && errorInput ? '0px 0px 4px #ff9e9e' : ''
                      }}
                      onChange={value => {
                        handleChange(rowIndex, 'ProductName', value.trimStart());
                      }}
                      // onChange={(value) => handleChange(rowIndex, 'ProductName', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {description && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.Description}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <Input
                      id="Description"
                      name="Description"
                      value={rowData && rowData.Description ? rowData.Description : ''}
                      onChange={value => handleChange(rowIndex, 'Description', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {size && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.Sizeunit}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {
                    (rowData, rowIndex) => (
                      <InputPicker
                        data={sizeUnit}
                        id="SizeUnit"
                        name="SizeUnit"
                        value={rowData && rowData.SizeUnit ? rowData.SizeUnit : ''}
                        onChange={value => handleChange(rowIndex, 'SizeUnit', value)}
                        placeholder="Select"
                        labelKey="label"
                        valueKey="value"
                        block
                      />
                    )
                    //  <Input
                    //   value={rowData.size}
                    //   onChange={(value) => handleChange(rowIndex, 'remarks', value)}
                    // />
                  }
                </Table.Cell>
              </Table.Column>
            )}
            {length && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.length}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <InputNumber
                      id="Length"
                      name="Length"
                      value={rowData && rowData.Length ? rowData.Length : ''}
                      onChange={value => handleChange(rowIndex, 'Length', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {width && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.width}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <InputNumber
                      id="Width"
                      name="Width"
                      value={rowData && rowData.Width ? rowData.Width : ''}
                      onChange={value => handleChange(rowIndex, 'Width', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {height && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.height}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <InputNumber
                      id="Height"
                      name="Height"
                      value={rowData && rowData.Height ? rowData.Height : ''}
                      onChange={value => handleChange(rowIndex, 'Height', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {cbm && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.cbm}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => <Input value={rowData.cbm} readOnly />}
                </Table.Cell>
              </Table.Column>
            )}
            {finish && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.finish}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {
                    (rowData, rowIndex) => (
                      <SelectPicker
                        id="FinishName"
                        name="FinishName"
                        value={rowData.FinishName || ''}
                        onChange={value => handleChange(rowIndex, 'FinishName', value)}
                        data={finishdata}
                        placeholder={rowData.FinishName}
                        menuMaxHeight={180}
                        // menuStyle={{ width: 200 }}
                        labelKey="label"
                        valueKey="label"
                        placement="auto"
                        block
                        onOpen={fetchData4}
                      />
                    )
                    //  <Input
                    //   value={rowData.samplingTime}
                    //   onChange={(value) => handleChange(rowIndex, 'samplingTime', value)}
                    // />
                  }
                </Table.Cell>
              </Table.Column>
            )}
            {color && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.color}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {
                    (rowData, rowIndex) => (
                      // <SelectPicker
                      //   id="ColorName"
                      //   name="ColorName"
                      //   value={rowData.ColorName || ''}
                      //   onChange={value => handleChange(rowIndex, 'ColorName', value)}
                      //   data={colordata}
                      //   placeholder={rowData.ColorName}
                      //   menuMaxHeight={180}
                      //   // menuStyle={{ width: 200 }}
                      //   labelKey="label"
                      //   valueKey="label"
                      //   block
                      //   placement="auto"
                      //   onOpen={fetchData5}
                      // />
                      <SelectPicker
                        id="ColorName"
                        name="ColorName"
                        value={rowData.ColorName || ''}
                        onChange={value => handleChange(rowIndex, 'ColorName', value)}
                        data={colordata}
                        placeholder="Select Color"
                        menuMaxHeight={180}
                        labelKey="label"
                        valueKey="label" // Display ke liye label use kar rahe hain
                        block
                        placement="auto"
                        onOpen={fetchData5}
                      />
                    )
                    //  <Input
                    //   value={rowData.color}
                    //   onChange={(value) => handleChange(rowIndex, 'color', value)}
                    // />
                  }
                </Table.Cell>
              </Table.Column>
            )}

            {netWeight && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.NetWgt}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <InputNumber
                      id="NetWeight"
                      name="NetWeight"
                      value={rowData && rowData.NetWeight ? rowData.NetWeight : ''}
                      onChange={value => handleChange(rowIndex, 'NetWeight', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {grossweight && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.GrossWgt}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <InputNumber
                      id="GrossWeight"
                      name="GrossWeight"
                      value={rowData && rowData.GrossWeight ? rowData.GrossWeight : ''}
                      onChange={value => handleChange(rowIndex, 'GrossWeight', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {hsn && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.HSN}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {
                    (rowData, rowIndex) => (
                      <SelectPicker
                        id="HSNCode"
                        name="HSNCode"
                        value={rowData && rowData.HSNCode ? rowData.HSNCode : ''}
                        onChange={value => handleChange(rowIndex, 'HSNCode', value)}
                        data={hsndata}
                        placeholder="Select"
                        menuMaxHeight={180}
                        // menuStyle={{ width: 200 }}
                        labelKey="label"
                        valueKey="value"
                        placement="auto"
                        block
                        onOpen={fetchData6}
                      />
                    )
                    //  <Input
                    //   value={rowData.priceFromeVendor}
                    //   onChange={(value) => handleChange(rowIndex, 'priceFromeVendor', value)}
                    // />
                  }
                </Table.Cell>
              </Table.Column>
            )}
            {sellingpriceC && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.Currency}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    // <Input id='SellingPriceCurrency' name="SellingPriceCurrency"
                    //   value={rowData && rowData.SellingPriceCurrency ? rowData.SellingPriceCurrency : ''}
                    //   onChange={value => handleChange(rowIndex, 'SellingPriceCurrency', value)} />
                    <SelectPicker
                      id="SellingPriceCurrency"
                      name="SellingPriceCurrency"
                      value={
                        rowData && rowData.SellingPriceCurrency ? rowData.SellingPriceCurrency : ''
                      }
                      onChange={value => handleChange(rowIndex, 'SellingPriceCurrency', value)}
                      data={curnrecy}
                      placeholder="Select"
                      labelKey="label"
                      valueKey="value"
                      placement="auto"
                      block
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {sellingpriceU && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.CurRate}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <InputNumber
                      id="SellingPriceUnit"
                      name="SellingPriceUnit"
                      value={rowData && rowData.SellingPriceUnit ? rowData.SellingPriceUnit : ''}
                      onChange={value => handleChange(rowIndex, 'SellingPriceUnit', value)}
                      readOnly={!selectedCurrency}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {sellingPrice && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.SalePrice}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <InputNumber
                      id="SellingPrice"
                      name="SellingPrice"
                      value={rowData && rowData.SellingPrice ? rowData.SellingPrice : ''}
                      onChange={value => handleChange(rowIndex, 'SellingPrice', value)}
                      readOnly={!selectedCurrency}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {productCost && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.SalePriceINR}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <Input
                      id="ProductCost"
                      name="ProductCost"
                      value={rowData && rowData.ProductCost ? rowData.ProductCost : ''}
                      onChange={value => handleChange(rowIndex, 'ProductCost', value)}
                      readOnly
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {searchKeyword && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.searchKeyword}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <Input
                      id="SearchKeyword"
                      name="SearchKeyword"
                      value={rowData && rowData.SearchKeyword ? rowData.SearchKeyword : ''}
                      onChange={value => handleChange(rowIndex, 'SearchKeyword', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {moq && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.MOQ}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <Input
                      id="MOQ"
                      name="MOQ"
                      value={rowData && rowData.MOQ ? rowData.MOQ : ''}
                      onChange={value => handleChange(rowIndex, 'MOQ', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {productDesigner && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.ProductDesigner}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <Input
                      id="ProductDesigner"
                      name="ProductDesigner"
                      value={rowData && rowData.ProductDesigner ? rowData.ProductDesigner : ''}
                      onChange={value => handleChange(rowIndex, 'ProductDesigner', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}

            {madeby && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.MadeBy}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <Input
                      id="MadeBy"
                      name="MadeBy"
                      value={rowData && rowData.MadeBy ? rowData.MadeBy : ''}
                      onChange={value => handleChange(rowIndex, 'MadeBy', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {buyername && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.BuyerName}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <SelectPicker
                      id="BuyerName"
                      name="BuyerName"
                      data={buyeerdata}
                      value={rowData.BuyerName || ''}
                      onChange={value => handleChange(rowIndex, 'BuyerName', value)}
                      placeholder="Select"
                      menuMaxHeight={180}
                      // menuStyle={{ width: 200 }}
                      labelKey="label"
                      valueKey="label"
                      block
                      placement="auto"
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}
            {buyersku && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.BuyerSku}</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <Input
                      id="BuyerSku"
                      name="BuyerSku"
                      value={rowData && rowData.BuyerSku ? rowData.BuyerSku : ''}
                      onChange={value => handleChange(rowIndex, 'BuyerSku', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}

            {/* Packaging Size Unit */}
            {packagingBulkUpload && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>Packaging Size Unit</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <SelectPicker
                      data={[
                        { label: 'CM', value: 'cm' },
                        { label: 'Inch', value: 'inch' }
                      ]}
                      value={rowData?.Packaging?.[0]?.Carton_Unit ?? ''}
                      onChange={value => handleChange(rowIndex, 'Carton_Unit', value)}
                      style={{ width: '100%' }}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}

            {/* Packaging Length */}
            {packagingBulkUpload && (
              <Table.Column width={120}>
                <Table.HeaderCell>
                  <b>Packaging Length</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <InputNumber
                      value={rowData?.Packaging?.[0]?.Carton_Length ?? 0}
                      onChange={value => handleChange(rowIndex, 'Carton_Length', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}

            {/* Packaging Width */}
            {packagingBulkUpload && (
              <Table.Column width={120}>
                <Table.HeaderCell>
                  <b>Packaging Width</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <InputNumber
                      value={rowData?.Packaging?.[0]?.Carton_Width ?? 0}
                      onChange={value => handleChange(rowIndex, 'Carton_Width', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}

            {/* Packaging Height (Carton Thick) */}
            {packagingBulkUpload && (
              <Table.Column width={120}>
                <Table.HeaderCell>
                  <b>Packaging Height</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <InputNumber
                      value={rowData?.Packaging?.[0]?.Carton_Thick ?? 0}
                      onChange={value => handleChange(rowIndex, 'Carton_Thick', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}

            {/* Packaging PCS */}
            {packagingBulkUpload && (
              <Table.Column width={120}>
                <Table.HeaderCell>
                  <b>Packaging PCS</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <InputNumber
                      value={rowData?.Packaging?.[0]?.Carton_PCS ?? 0}
                      onChange={value => handleChange(rowIndex, 'Carton_PCS', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}

            {/* Packaging CBM (auto-calculated) */}
            {/* <Table.Column width={120}>
  <Table.HeaderCell><b>Packaging CBM</b></Table.HeaderCell>
  <Table.Cell>
    {(rowData, rowIndex) => (
      <InputNumber
        value={rowData?.Packaging?.[0]?.Carton_CBM ?? 0}
        readOnly
      />
    )}
  </Table.Cell>
</Table.Column> */}
            {packagingBulkUpload && (
              <Table.Column width={120}>
                <Table.HeaderCell>
                  <b>Packaging CBM</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <InputNumber value={rowData?.Packaging?.[0]?.Carton_CBM ?? 0} readOnly />
                  )}
                </Table.Cell>
              </Table.Column>
            )}

            {/* Packaging Gross Wt. */}
            {packagingBulkUpload && (
              <Table.Column width={150}>
                <Table.HeaderCell>
                  <b>Packaging Gross Wt.</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {(rowData, rowIndex) => (
                    <InputNumber
                      value={rowData?.Packaging?.[0]?.Carton_GrsWt ?? 0}
                      onChange={value => handleChange(rowIndex, 'Carton_GrsWt', value)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            )}

            <Table.Column width={100} fixed="right">
              <Table.HeaderCell>
                <b>Action</b>
              </Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => (
                  <IconButton
                    icon={<TrashIcon />}
                    active
                    appearance="default"
                    onClick={() => handleRemoveRow(rowIndex)} // Pass the rowIndex to the function
                    disabled={rows.length === 1}
                  />
                )}
              </Table.Cell>
            </Table.Column>
          </Table>

          {/* Your other JSX elements */}
        </>

        {/* <Stack>
          <Button appearance="primary" color="cyan" onClick={handleAddRow} id="add">
            Add Product
          </Button>
        </Stack> */}

        {/* Customize modal start */}
        <Modal size={size1} backdrop="static" open={open} onClose={handleClose}>
          <Modal.Header>
            <Modal.Title>
              <b>Confirm the Attributes</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Checkbox
              checked={selectAll}
              onChange={() => {
                allcheckbox(!selectAll);
                setSelectAll(!selectAll);
              }}
            >
              Select All
            </Checkbox>
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={category} onChange={handlecategoryCheckbox}>
                  {label[0]?.attributes.Category}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={Productype} onChange={handlesubCategoryCheckbox}>
                  {label[0]?.attributes.ProductType}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={sellingPrice} onChange={handlesellingPriceCheckbox}>
                  {label[0]?.attributes.SalePrice}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={moq} onChange={handlemoqCheckbox}>
                  {label[0]?.attributes.MOQ}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={description} onChange={handledescriptionCheckbox}>
                  {label[0]?.attributes.Description}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={searchKeyword} onChange={handlesearchKeywordCheckbox}>
                  {label[0]?.attributes.searchKeyword}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productCost} onChange={handleproductCostCheckbox}>
                  {label[0]?.attributes.SalePriceINR}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={color} onChange={handlecolorCheckbox}>
                  {label[0]?.attributes.color}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={size} onChange={handlesizeCheckbox}>
                  {label[0]?.attributes.Sizeunit}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={length} onChange={handlelenghtCheckbox}>
                  {label[0]?.attributes.length}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={width} onChange={handlewidthCheckbox}>
                  {label[0]?.attributes.width}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={height} onChange={handleheightCheckbox}>
                  {label[0]?.attributes.height}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={cbm} onChange={handlecbmCheckbox}>
                  {label[0]?.attributes.cbm}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productID} onChange={handlenameCheckbox}>
                  {label[0]?.attributes.AliasCode}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productname} onChange={handleproductionTimeCheckbox}>
                  {label[0]?.attributes.ProductName}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={finish} onChange={handleremarksCheckbox}>
                  {label[0]?.attributes.finish}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={netWeight} onChange={handlesamplingTimeCheckbox}>
                  {label[0]?.attributes.NetWgt}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={grossweight} onChange={handleproductionTechCheckbox}>
                  {label[0]?.attributes.GrossWgt}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={hsn} onChange={handlepriceFromeVendorCheckbox}>
                  {label[0]?.attributes.HSN}
                </Checkbox>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={sellingpriceU} onChange={handledispatchDataCheckbox}>
                  {label[0]?.attributes.CurRate}
                </Checkbox>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={sellingpriceC} onChange={handleseasonCheckbox}>
                  {label[0]?.attributes.Currency}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productDesigner} onChange={handleexclusiveForCheckbox}>
                  {label[0]?.attributes.ProductDesigner}
                </Checkbox>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={madeby} onChange={handleshapeCheckbox}>
                  {label[0]?.attributes.MadeBy}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={buyername} onChange={handlevendornameCheckbox}>
                  {label[0]?.attributes.BuyerName}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={buyersku} onChange={handlethemeCheckbox}>
                  {label[0]?.attributes.BuyerSku}
                </Checkbox>
              </FlexboxGrid.Item>
              {/* <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={image} onChange={handleimageCheckbox}>
                  <b> Include Product Image</b>
                </Checkbox>
              </FlexboxGrid.Item> */}
            </FlexboxGrid>
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent="space-between">
              <Button onClick={handleClose} appearance="ghost" color="cyan">
                Cancel
              </Button>
              <Button onClick={handleClose} appearance="primary" color="cyan">
                Done
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>
        <Modal backdrop="static" open={isModalVisible}>
          <Modal.Body>
            {/* Modal content goes here */}
            <Stack direction="column" justifyContent="center">
              <div>
                <label htmlFor="file-upload" className="custom-file-upload img-bulk-btn">
                  <i className="fas fa-cloud-upload-alt"></i> Upload Images
                </label>
                <input
                  id="file-upload"
                  type="file"
                  multiple
                  onChange={e => handleImageUploadq(e.target.files)}
                  accept="image/*"
                />
              </div>
              {uploadedImages.length > 0 && (
                <div style={{ marginTop: '10px' }}>
                  {/* Display the number of uploaded images */}
                  <b>{uploadedImages.length} Images Uploaded</b>
                </div>
              )}
              <p style={{ color: 'red' }}>Maximum Size 25mb*</p>
            </Stack>
          </Modal.Body>
          <Modal.Footer>
            {/* Button to close the modal */}
            <Button onClick={cencel} appearance="default" active>
              Cancel
            </Button>

            <Button onClick={closeModal} appearance="primary" color="cyan">
              Next
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal open={open4} onClose={handleClose4} backdrop="static">
          <Modal.Header>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Stack direction="column">
              <Icon
                as={CheckOutlineIcon}
                color="cyan"
                style={{ fontSize: '100px', marginBottom: '20px' }}
              />
              <b>
                {rows.length} Product{rows.length > 1 ? 's' : ''} Saved Successfully
              </b>
            </Stack>
          </Modal.Body>
          <Modal.Footer>
            <Stack alignItems="flex-end" justifyContent="flex-end">
              <Button appearance="primary" color="cyan" onClick={handleClose4}>
                Ok
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>
        {/* Customize modal End */}
        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERPDaddy Software Solution.
            </a>
          </p>
        </Stack>
      </Container>
      <Modal open={showModal} onClose={() => setShowModal(false)}>
        <Modal.Header>
          <Modal.Title>Skipped Rows</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {skippedRowsInfo.length > 0 ? (
            <>
              <p>The following rows were skipped due to errors:</p>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f5f5f5', textAlign: 'left' }}>
                    <th style={{ border: '1px solid #ddd', padding: '8px' }}>Row No</th>
                    <th style={{ border: '1px solid #ddd', padding: '8px' }}>Error Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {skippedRowsInfo.map((row: any, idx: number) => (
                    <tr key={idx} style={{ color: 'red', border: '1px solid #ddd' }}>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{row.row}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{row.reason}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          ) : (
            <p>All rows were processed successfully!</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowModal(false)} appearance="primary">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BulkProduct;
